import { i18n, TFunction } from "i18next";

export type SecurityCode =
  | "btc"
  | "eth"
  | "xrp"
  | "ltc"
  | "eos"
  | "ada"
  | "avax"
  | "comp"
  | "dot"
  | "ksm"
  | "link"
  | "matic"
  | "sol"
  | "uni"
  | "usdc"
  | "xlm"
  | "atom"
  | "near"
  | "trx"
  | "aave"
  | "xtz"
  | "bch"
  | "etc"
  | "doge"
  | "glmr"
  | "xdc"
  | "algo"
  | "ape"
  | "gala"
  | "grt"
  | "mana"
  | "sand"
  | "pol"
  | "abt"
  | "aca"
  | "ace"
  | "act"
  | "acx"
  | "adx"
  | "aergo"
  | "aero"
  | "agld"
  | "aioz"
  | "aixbt"
  | "alice"
  | "alpha"
  | "alt"
  | "amp"
  | "anime"
  | "ark"
  | "arpa"
  | "ata"
  | "ath"
  | "auction"
  | "ava"
  | "axl"
  | "baby"
  | "banana"
  | "band"
  | "bel"
  | "bico"
  | "bigtime"
  | "bio"
  | "blast"
  | "blz"
  | "bnb"
  | "bnt"
  | "bome"
  | "brett"
  | "c98"
  | "cake"
  | "cati"
  | "celo"
  | "celr"
  | "cetus"
  | "cfx"
  | "chillguy"
  | "chr"
  | "ckb"
  | "clv"
  | "core"
  | "cos"
  | "coti"
  | "cow"
  | "cro"
  | "cspr"
  | "ctc"
  | "ctk"
  | "ctsi"
  | "cvx"
  | "cyber"
  | "d"
  | "data"
  | "dbr"
  | "dcr"
  | "deep"
  | "degen"
  | "dent"
  | "dgb"
  | "dia"
  | "dnt"
  | "dodo"
  | "dogs"
  | "dusk"
  | "dym"
  | "edu"
  | "elx"
  | "epic"
  | "europ"
  | "f"
  | "fis"
  | "Flux"
  | "form4"
  | "forth"
  | "fueln"
  | "g"
  | "gas"
  | "ghst"
  | "giga"
  | "glm"
  | "gns"
  | "goat"
  | "grass"
  | "hei"
  | "hifi"
  | "high"
  | "hmstr"
  | "hook"
  | "hot"
  | "hypel"
  | "id"
  | "idex"
  | "ilv"
  | "io"
  | "iost"
  | "iota"
  | "iotx"
  | "ip"
  | "iq"
  | "jst"
  | "kaia"
  | "kaito"
  | "kda"
  | "kernel"
  | "kmd"
  | "knc"
  | "lista"
  | "lqty"
  | "lsk"
  | "lto"
  | "lumia"
  | "lyx"
  | "magic"
  | "manta"
  | "mask"
  | "mav"
  | "mavia"
  | "mbox"
  | "mdt"
  | "me"
  | "meme"
  | "merl"
  | "metis"
  | "mew"
  | "michi"
  | "moca"
  | "moodeng"
  | "morpho"
  | "move"
  | "mtl"
  | "nano"
  | "neiro"
  | "neo"
  | "nfp"
  | "nil"
  | "nkn"
  | "nmr"
  | "not"
  | "npc"
  | "ogn"
  | "om"
  | "omni"
  | "one"
  | "ong"
  | "ont"
  | "ordi"
  | "osmo"
  | "oxt"
  | "parti"
  | "peaq"
  | "pengu"
  | "people"
  | "pha"
  | "phb"
  | "pixel"
  | "plume"
  | "pnut"
  | "pols"
  | "polyx"
  | "pond"
  | "ponke"
  | "portal"
  | "powr"
  | "prom"
  | "prompt"
  | "puffer"
  | "pundix"
  | "pyr"
  | "qkc"
  | "qtum"
  | "rad"
  | "rare"
  | "rdnt"
  | "red"
  | "req"
  | "rez"
  | "rlc"
  | "ronin"
  | "rose"
  | "rsr"
  | "rvn"
  | "s"
  | "safe"
  | "scr"
  | "sfp"
  | "skl"
  | "slf"
  | "slp"
  | "spx"
  | "ssv"
  | "strax"
  | "sweat"
  | "swell"
  | "sxp"
  | "tai"
  | "taiko"
  | "the"
  | "theta"
  | "tlm"
  | "token"
  | "trac"
  | "trb"
  | "trumpofficial"
  | "twt"
  | "uma"
  | "utk"
  | "uxlink"
  | "vana"
  | "vanry"
  | "velo"
  | "vet"
  | "vic"
  | "virtual"
  | "vra"
  | "vtho"
  | "wal"
  | "waxp"
  | "wct"
  | "win"
  | "wld"
  | "woo"
  | "xai"
  | "xvg"
  | "xyo"
  | "ygg"
  | "zen"
  | "zil"
  | "zrc"
  | "zro"
  | "init"
  | "soph"
  | "gtc"
  | "fartcoin"
  | "shell"
  | "a"
  | "xion"
  | "sxt"
  | "haedal"
  | "home"
  | "spk"
  | "newt"
  | "sign"
  | "icnt"
  | "dmc"
  | "huma"
  | "pump"
  | "ika"
  | "tree"
  | "sqd"
  | "towns"
  | "prove";

export type SecurityCodeSek =
  | "btcsek"
  | "ethsek"
  | "xrpsek"
  | "ltcsek"
  | "eossek"
  | "adasek"
  | "avaxsek"
  | "compsek"
  | "dotsek"
  | "ksmsek"
  | "linksek"
  | "maticsek"
  | "solsek"
  | "unisek"
  | "usdcsek"
  | "xlmsek"
  | "atomsek"
  | "nearsek"
  | "trxsek"
  | "aavesek"
  | "xtzsek"
  | "bchsek"
  | "etcsek"
  | "dogesek"
  | "glmrsek"
  | "xdcsek"
  | "algosek"
  | "apesek"
  | "galasek"
  | "grtsek"
  | "manasek"
  | "sandsek";

export const VALID_SECURITY_CODES: SecurityCode[] = [
  "btc",
  "eth",
  "xrp",
  "ltc",
  "eos",
  "ada",
  "avax",
  "comp",
  "dot",
  "ksm",
  "link",
  "matic",
  "sol",
  "uni",
  "usdc",
  "xlm",
  "atom",
  "near",
  "trx",
  "aave",
  "xtz",
  "bch",
  "etc",
  "doge",
  "glmr",
  "xdc",
  "algo",
  "ape",
  "gala",
  "grt",
  "mana",
  "sand",
  "pol",
  "abt",
  "aca",
  "ace",
  "act",
  "acx",
  "adx",
  "aergo",
  "aero",
  "agld",
  "aioz",
  "aixbt",
  "alice",
  "alpha",
  "alt",
  "amp",
  "anime",
  "ark",
  "arpa",
  "ata",
  "ath",
  "auction",
  "ava",
  "axl",
  "baby",
  "banana",
  "band",
  "bel",
  "bico",
  "bigtime",
  "bio",
  "blast",
  "blz",
  "bnb",
  "bnt",
  "bome",
  "brett",
  "c98",
  "cake",
  "cati",
  "celo",
  "celr",
  "cetus",
  "cfx",
  "chillguy",
  "chr",
  "ckb",
  "clv",
  "core",
  "cos",
  "coti",
  "cow",
  "cro",
  "cspr",
  "ctc",
  "ctk",
  "ctsi",
  "cvx",
  "cyber",
  "d",
  "data",
  "dbr",
  "dcr",
  "deep",
  "degen",
  "dent",
  "dgb",
  "dia",
  "dnt",
  "dodo",
  "dogs",
  "dusk",
  "dym",
  "edu",
  "elx",
  "epic",
  "europ",
  "f",
  "fis",
  "Flux",
  "form4",
  "forth",
  "fueln",
  "g",
  "gas",
  "ghst",
  "giga",
  "glm",
  "gns",
  "goat",
  "grass",
  "hei",
  "hifi",
  "high",
  "hmstr",
  "hook",
  "hot",
  "hypel",
  "id",
  "idex",
  "ilv",
  "io",
  "iost",
  "iota",
  "iotx",
  "ip",
  "iq",
  "jst",
  "kaia",
  "kaito",
  "kda",
  "kernel",
  "kmd",
  "knc",
  "lista",
  "lqty",
  "lsk",
  "lto",
  "lumia",
  "lyx",
  "magic",
  "manta",
  "mask",
  "mav",
  "mavia",
  "mbox",
  "mdt",
  "me",
  "meme",
  "merl",
  "metis",
  "mew",
  "michi",
  "moca",
  "moodeng",
  "morpho",
  "move",
  "mtl",
  "nano",
  "neiro",
  "neo",
  "nfp",
  "nil",
  "nkn",
  "nmr",
  "not",
  "npc",
  "ogn",
  "om",
  "omni",
  "one",
  "ong",
  "ont",
  "ordi",
  "osmo",
  "oxt",
  "parti",
  "peaq",
  "pengu",
  "people",
  "pha",
  "phb",
  "pixel",
  "plume",
  "pnut",
  "pols",
  "polyx",
  "pond",
  "ponke",
  "portal",
  "powr",
  "prom",
  "prompt",
  "puffer",
  "pundix",
  "pyr",
  "qkc",
  "qtum",
  "rad",
  "rare",
  "rdnt",
  "red",
  "req",
  "rez",
  "rlc",
  "ronin",
  "rose",
  "rsr",
  "rvn",
  "s",
  "safe",
  "scr",
  "sfp",
  "skl",
  "slf",
  "slp",
  "spx",
  "ssv",
  "strax",
  "sweat",
  "swell",
  "sxp",
  "tai",
  "taiko",
  "the",
  "theta",
  "tlm",
  "token",
  "trac",
  "trb",
  "trumpofficial",
  "twt",
  "uma",
  "utk",
  "uxlink",
  "vana",
  "vanry",
  "velo",
  "vet",
  "vic",
  "virtual",
  "vra",
  "vtho",
  "wal",
  "waxp",
  "wct",
  "win",
  "wld",
  "woo",
  "xai",
  "xvg",
  "xyo",
  "ygg",
  "zen",
  "zil",
  "zrc",
  "zro",
  "init",
  "soph",
  "gtc",
  "fartcoin",
  "shell",
  "a",
  "xion",
  "sxt",
  "haedal",
  "home",
  "spk",
  "newt",
  "sign",
  "icnt",
  "dmc",
  "huma",
  "pump",
  "ika",
  "tree",
  "sqd",
  "towns",
  "prove",
];

export const VALID_SECURITY_CODES_SEK: SecurityCodeSek[] = [
  "btcsek",
  "ethsek",
  "xrpsek",
  "ltcsek",
  "eossek",
  "adasek",
  "avaxsek",
  "compsek",
  "dotsek",
  "ksmsek",
  "linksek",
  "maticsek",
  "solsek",
  "unisek",
  "usdcsek",
  "xlmsek",
  "atomsek",
  "nearsek",
  "trxsek",
  "aavesek",
  "xtzsek",
  "bchsek",
  "etcsek",
  "dogesek",
  "glmrsek",
  "xdcsek",
  "algosek",
  "apesek",
  "galasek",
  "grtsek",
  "manasek",
  "sandsek",
];

// FA security codes
export type SecurityCodeWithoutTransferSupport =
  | "apt"
  | "arb"
  | "ar"
  | "fil"
  | "flow"
  | "icp"
  | "sui"
  | "bal"
  | "bat"
  | "blur"
  | "crv"
  | "hbar"
  | "imx"
  | "mkr"
  | "qnt"
  | "snx"
  | "yfi"
  | "1inch"
  | "ach"
  | "aevo"
  | "akt"
  | "ankr"
  | "api3"
  | "astr"
  | "atlas"
  | "audio"
  | "axs"
  | "beam"
  | "bond"
  | "bonk"
  | "cfg"
  | "chz"
  | "dydx"
  | "egld"
  | "ena"
  | "enj"
  | "ens"
  | "ethfi"
  | "fet"
  | "fida"
  | "flr"
  | "fxs"
  | "gmx"
  | "gno"
  | "hft"
  | "hnt"
  | "inj"
  | "jasmy"
  | "jto"
  | "jup"
  | "kava"
  | "ldo"
  | "lmwr"
  | "lpt"
  | "mina"
  | "mln"
  | "movr"
  | "mpl"
  | "nos"
  | "ocean"
  | "omg"
  | "ondo"
  | "op"
  | "orca"
  | "pepe"
  | "perp"
  | "pyth"
  | "rari"
  | "ray"
  | "ren"
  | "rndr"
  | "rpl"
  | "rune"
  | "sc"
  | "sei"
  | "shib"
  | "strk"
  | "stx"
  | "super"
  | "sushi"
  | "tia"
  | "tnsr"
  | "tru"
  | "w"
  | "waves"
  | "wen"
  | "wif"
  | "zeus"
  | "zrx"
  | "arkm"
  | "tao"
  | "btt"
  | "cvc"
  | "cpool"
  | "cloud"
  | "drift"
  | "prime"
  | "eigen"
  | "ewt"
  | "eurc"
  | "eul"
  | "floki"
  | "gmt"
  | "honey"
  | "icx"
  | "kmno"
  | "l3"
  | "lrc"
  | "mc"
  | "mog"
  | "prcl"
  | "pendle"
  | "popcat"
  | "saga"
  | "scrt"
  | "sky"
  | "stg"
  | "step"
  | "storj"
  | "syn"
  | "t"
  | "turbo"
  | "zeta"
  | "zex"
  | "zk"
  | "mnt"
  | "ton"
  | "syrup"
  | "kas"
  | "render"
  | "abt"
  | "aca"
  | "ace"
  | "act"
  | "acx"
  | "adx"
  | "aergo"
  | "aero"
  | "agld"
  | "aioz"
  | "aixbt"
  | "alice"
  | "alpha"
  | "alt"
  | "amp"
  | "anime"
  | "ark"
  | "arpa"
  | "ata"
  | "ath"
  | "auction"
  | "ava"
  | "axl"
  | "baby"
  | "banana"
  | "band"
  | "bel"
  | "bico"
  | "bigtime"
  | "bio"
  | "blast"
  | "blz"
  | "bnb"
  | "bnt"
  | "bome"
  | "brett"
  | "c98"
  | "cake"
  | "cati"
  | "celo"
  | "celr"
  | "cetus"
  | "cfx"
  | "chillguy"
  | "chr"
  | "ckb"
  | "clv"
  | "core"
  | "cos"
  | "coti"
  | "cow"
  | "cro"
  | "cspr"
  | "ctc"
  | "ctk"
  | "ctsi"
  | "cvx"
  | "cyber"
  | "d"
  | "data"
  | "dbr"
  | "dcr"
  | "deep"
  | "degen"
  | "dent"
  | "dgb"
  | "dia"
  | "dnt"
  | "dodo"
  | "dogs"
  | "dusk"
  | "dym"
  | "edu"
  | "elx"
  | "epic"
  | "europ"
  | "f"
  | "fis"
  | "Flux"
  | "form4"
  | "forth"
  | "fueln"
  | "g"
  | "gas"
  | "ghst"
  | "giga"
  | "glm"
  | "gns"
  | "goat"
  | "grass"
  | "hei"
  | "hifi"
  | "high"
  | "hmstr"
  | "hook"
  | "hot"
  | "hypel"
  | "id"
  | "idex"
  | "ilv"
  | "io"
  | "iost"
  | "iota"
  | "iotx"
  | "ip"
  | "iq"
  | "jst"
  | "kaia"
  | "kaito"
  | "kda"
  | "kernel"
  | "kmd"
  | "knc"
  | "lista"
  | "lqty"
  | "lsk"
  | "lto"
  | "lumia"
  | "lyx"
  | "magic"
  | "manta"
  | "mask"
  | "mav"
  | "mavia"
  | "mbox"
  | "mdt"
  | "me"
  | "meme"
  | "merl"
  | "metis"
  | "mew"
  | "michi"
  | "moca"
  | "moodeng"
  | "morpho"
  | "move"
  | "mtl"
  | "nano"
  | "neiro"
  | "neo"
  | "nfp"
  | "nil"
  | "nkn"
  | "nmr"
  | "not"
  | "npc"
  | "ogn"
  | "om"
  | "omni"
  | "one"
  | "ong"
  | "ont"
  | "ordi"
  | "osmo"
  | "oxt"
  | "parti"
  | "peaq"
  | "pengu"
  | "people"
  | "pha"
  | "phb"
  | "pixel"
  | "plume"
  | "pnut"
  | "pols"
  | "polyx"
  | "pond"
  | "ponke"
  | "portal"
  | "powr"
  | "prom"
  | "prompt"
  | "puffer"
  | "pundix"
  | "pyr"
  | "qkc"
  | "qtum"
  | "rad"
  | "rare"
  | "rdnt"
  | "red"
  | "req"
  | "rez"
  | "rlc"
  | "ronin"
  | "rose"
  | "rsr"
  | "rvn"
  | "s"
  | "safe"
  | "scr"
  | "sfp"
  | "skl"
  | "slf"
  | "slp"
  | "spx"
  | "ssv"
  | "strax"
  | "sweat"
  | "swell"
  | "sxp"
  | "tai"
  | "taiko"
  | "the"
  | "theta"
  | "tlm"
  | "token"
  | "trac"
  | "trb"
  | "trumpofficial"
  | "twt"
  | "uma"
  | "utk"
  | "uxlink"
  | "vana"
  | "vanry"
  | "velo"
  | "vet"
  | "vic"
  | "virtual"
  | "vra"
  | "vtho"
  | "wal"
  | "waxp"
  | "wct"
  | "win"
  | "wld"
  | "woo"
  | "xai"
  | "xvg"
  | "xyo"
  | "ygg"
  | "zen"
  | "zil"
  | "zrc"
  | "zro"
  | "init"
  | "soph"
  | "gtc"
  | "fartcoin"
  | "shell"
  | "a"
  | "xion"
  | "sxt"
  | "haedal"
  | "home"
  | "spk"
  | "newt"
  | "sign"
  | "icnt"
  | "dmc"
  | "huma"
  | "pump"
  | "ika"
  | "tree"
  | "sqd"
  | "towns"
  | "prove";

export const SECURITY_CODES_WITHOUT_TRANSFER_SUPPORT: SecurityCodeWithoutTransferSupport[] =
  [
    "apt",
    "arb",
    "ar",
    "fil",
    "flow",
    "icp",
    "sui",
    "bal",
    "bat",
    "blur",
    "crv",
    "hbar",
    "imx",
    "mkr",
    "qnt",
    "snx",
    "yfi",
    "1inch",
    "ach",
    "aevo",
    "akt",
    "ankr",
    "api3",
    "astr",
    "atlas",
    "audio",
    "axs",
    "beam",
    "bond",
    "bonk",
    "cfg",
    "chz",
    "dydx",
    "egld",
    "ena",
    "enj",
    "ens",
    "ethfi",
    "fet",
    "fida",
    "flr",
    "fxs",
    "gmx",
    "gno",
    "hft",
    "hnt",
    "inj",
    "jasmy",
    "jto",
    "jup",
    "kava",
    "ldo",
    "lmwr",
    "lpt",
    "mina",
    "mln",
    "movr",
    "mpl",
    "nos",
    "ocean",
    "omg",
    "ondo",
    "op",
    "orca",
    "pepe",
    "perp",
    "pyth",
    "rari",
    "ray",
    "ren",
    "rndr",
    "rpl",
    "rune",
    "sc",
    "sei",
    "shib",
    "strk",
    "stx",
    "super",
    "sushi",
    "tia",
    "tnsr",
    "tru",
    "w",
    "waves",
    "wen",
    "wif",
    "zeus",
    "zrx",
    "arkm",
    "tao",
    "btt",
    "cvc",
    "cpool",
    "cloud",
    "drift",
    "prime",
    "eigen",
    "ewt",
    "eurc",
    "eul",
    "floki",
    "gmt",
    "honey",
    "icx",
    "kmno",
    "l3",
    "lrc",
    "mc",
    "mog",
    "prcl",
    "pendle",
    "popcat",
    "saga",
    "scrt",
    "sky",
    "stg",
    "step",
    "storj",
    "syn",
    "t",
    "turbo",
    "zeta",
    "zex",
    "zk",
    "mnt",
    "ton",
    "syrup",
    "kas",
    "render",
    "abt",
    "aca",
    "ace",
    "act",
    "acx",
    "adx",
    "aergo",
    "aero",
    "agld",
    "aioz",
    "aixbt",
    "alice",
    "alpha",
    "alt",
    "amp",
    "anime",
    "ark",
    "arpa",
    "ata",
    "ath",
    "auction",
    "ava",
    "axl",
    "baby",
    "banana",
    "band",
    "bel",
    "bico",
    "bigtime",
    "bio",
    "blast",
    "blz",
    "bnb",
    "bnt",
    "bome",
    "brett",
    "c98",
    "cake",
    "cati",
    "celo",
    "celr",
    "cetus",
    "cfx",
    "chillguy",
    "chr",
    "ckb",
    "clv",
    "core",
    "cos",
    "coti",
    "cow",
    "cro",
    "cspr",
    "ctc",
    "ctk",
    "ctsi",
    "cvx",
    "cyber",
    "d",
    "data",
    "dbr",
    "dcr",
    "deep",
    "degen",
    "dent",
    "dgb",
    "dia",
    "dnt",
    "dodo",
    "dogs",
    "dusk",
    "dym",
    "edu",
    "elx",
    "epic",
    "europ",
    "f",
    "fis",
    "Flux",
    "form4",
    "forth",
    "fueln",
    "g",
    "gas",
    "ghst",
    "giga",
    "glm",
    "gns",
    "goat",
    "grass",
    "hei",
    "hifi",
    "high",
    "hmstr",
    "hook",
    "hot",
    "hypel",
    "id",
    "idex",
    "ilv",
    "io",
    "iost",
    "iota",
    "iotx",
    "ip",
    "iq",
    "jst",
    "kaia",
    "kaito",
    "kda",
    "kernel",
    "kmd",
    "knc",
    "lista",
    "lqty",
    "lsk",
    "lto",
    "lumia",
    "lyx",
    "magic",
    "manta",
    "mask",
    "mav",
    "mavia",
    "mbox",
    "mdt",
    "me",
    "meme",
    "merl",
    "metis",
    "mew",
    "michi",
    "moca",
    "moodeng",
    "morpho",
    "move",
    "mtl",
    "nano",
    "neiro",
    "neo",
    "nfp",
    "nil",
    "nkn",
    "nmr",
    "not",
    "npc",
    "ogn",
    "om",
    "omni",
    "one",
    "ong",
    "ont",
    "ordi",
    "osmo",
    "oxt",
    "parti",
    "peaq",
    "pengu",
    "people",
    "pha",
    "phb",
    "pixel",
    "plume",
    "pnut",
    "pols",
    "polyx",
    "pond",
    "ponke",
    "portal",
    "powr",
    "prom",
    "prompt",
    "puffer",
    "pundix",
    "pyr",
    "qkc",
    "qtum",
    "rad",
    "rare",
    "rdnt",
    "red",
    "req",
    "rez",
    "rlc",
    "ronin",
    "rose",
    "rsr",
    "rvn",
    "s",
    "safe",
    "scr",
    "sfp",
    "skl",
    "slf",
    "slp",
    "spx",
    "ssv",
    "strax",
    "sweat",
    "swell",
    "sxp",
    "tai",
    "taiko",
    "the",
    "theta",
    "tlm",
    "token",
    "trac",
    "trb",
    "trumpofficial",
    "twt",
    "uma",
    "utk",
    "uxlink",
    "vana",
    "vanry",
    "velo",
    "vet",
    "vic",
    "virtual",
    "vra",
    "vtho",
    "wal",
    "waxp",
    "wct",
    "win",
    "wld",
    "woo",
    "xai",
    "xvg",
    "xyo",
    "ygg",
    "zen",
    "zil",
    "zrc",
    "zro",
    "init",
    "soph",
    "gtc",
    "fartcoin",
    "shell",
    "a",
    "xion",
    "sxt",
    "haedal",
    "home",
    "spk",
    "newt",
    "sign",
    "icnt",
    "dmc",
    "huma",
    "pump",
    "ika",
    "tree",
    "sqd",
    "towns",
    "prove",
  ];

// FA security codes
export type SecurityCodeWithTransfersupport =
  | "btc"
  | "eth"
  | "xrp"
  | "ltc"
  | "eos"
  | "ada"
  | "avax"
  | "comp"
  | "dot"
  | "ksm"
  | "link"
  | "matic"
  | "sol"
  | "uni"
  | "usdc"
  | "xlm"
  | "atom"
  | "near"
  | "trx"
  | "aave"
  | "xtz"
  | "bch"
  | "etc"
  | "doge"
  | "glmr"
  | "xdc"
  | "algo"
  | "ape"
  | "gala"
  | "grt"
  | "mana"
  | "sand"
  | "pol";

export const VALID_SECURITY_CODES_WITH_TRANSFER_SUPPORT: SecurityCodeWithTransfersupport[] =
  [
    "btc",
    "eth",
    "xrp",
    "ltc",
    "eos",
    "ada",
    "avax",
    "comp",
    "dot",
    "ksm",
    "link",
    "matic",
    "sol",
    "uni",
    "usdc",
    "xlm",
    "atom",
    "near",
    "trx",
    "aave",
    "xtz",
    "bch",
    "etc",
    "doge",
    "glmr",
    "xdc",
    "algo",
    "ape",
    "gala",
    "grt",
    "mana",
    "sand",
    "pol",
  ];

export type AssetId =
  | "BTC"
  | "ETH"
  | "XRP"
  | "LTC"
  | "EOS"
  | "ADA"
  | "AVAX"
  | "COMP"
  | "DOT"
  | "KSM"
  | "LINK"
  | "MATIC"
  | "SOL"
  | "UNI"
  | "USDC"
  | "XLM"
  | "ATOM_COS"
  | "NEAR"
  | "TRX"
  | "AAVE"
  | "XTZ"
  | "BCH"
  | "ETC"
  | "DOGE"
  | "GLMR_GLMR"
  | "XDC"
  | "ALGO"
  | "APE_ETH"
  | "GALA2"
  | "GRT"
  | "MANA"
  | "SAND"
  | "POL";

export const VALID_ASSET_IDS: AssetId[] = [
  "BTC",
  "ETH",
  "XRP",
  "LTC",
  "EOS",
  "ADA",
  "AVAX",
  "COMP",
  "DOT",
  "KSM",
  "LINK",
  "MATIC",
  "SOL",
  "UNI",
  "USDC",
  "XLM",
  "ATOM_COS",
  "NEAR",
  "TRX",
  "AAVE",
  "XTZ",
  "BCH",
  "ETC",
  "DOGE",
  "GLMR_GLMR",
  "XDC",
  "ALGO",
  "APE_ETH",
  "GALA2",
  "GRT",
  "MANA",
  "SAND",
  "POL",
];

export type CurrencyCode = "EUR" | "SEK";

export const VALID_CURRENCY_CODES: CurrencyCode[] = ["EUR", "SEK"];

export const isSecurityCode = (
  securityCode: string
): securityCode is SecurityCode => {
  return VALID_SECURITY_CODES.includes(securityCode as SecurityCode);
};

export const isAssetId = (assetId: string): assetId is AssetId => {
  return VALID_ASSET_IDS.includes(assetId as AssetId);
};

export const isFiatCurrencyCode = (
  codeToTest: string
): codeToTest is CurrencyCode => {
  return codeToTest === "EUR" || codeToTest === "SEK";
};

export const ASSET_ID_TO_SECURITY_CODE: Record<AssetId, SecurityCode> = {
  BTC: "btc",
  ETH: "eth",
  XRP: "xrp",
  LTC: "ltc",
  EOS: "eos",
  ADA: "ada",
  AVAX: "avax",
  COMP: "comp",
  DOT: "dot",
  KSM: "ksm",
  LINK: "link",
  MATIC: "matic",
  SOL: "sol",
  UNI: "uni",
  USDC: "usdc",
  XLM: "xlm",
  ATOM_COS: "atom",
  NEAR: "near",
  TRX: "trx",
  AAVE: "aave",
  XTZ: "xtz",
  BCH: "bch",
  ETC: "etc",
  DOGE: "doge",
  GLMR_GLMR: "glmr",
  XDC: "xdc",
  ALGO: "algo",
  APE_ETH: "ape",
  GALA2: "gala",
  GRT: "grt",
  MANA: "mana",
  SAND: "sand",
  POL: "pol",
};

export const ASSET_ID_TO_CHAIN: Record<AssetId, string> = {
  BTC: "Bitcoin blockchain",
  ETH: "Ethereum blockchain",
  XRP: "XRP Ledger",
  LTC: "Litecoin blockchain",
  EOS: "EOS blockchain",
  ADA: "Cardano blockchain",
  AVAX: "Avalanche blockchain",
  COMP: "Ethereum blockchain (ERC-20)",
  DOT: "Polkadot blockchain",
  KSM: "Kusama blockchain",
  LINK: "Ethereum blockchain (ERC-20)",
  MATIC: "Polygon blockchain",
  SOL: "Solana blockchain",
  UNI: "Ethereum blockchain (ERC-20)",
  USDC: "Ethereum blockchain (ERC-20)",
  XLM: "Stellar blockchain",
  ATOM_COS: "Cosmos blockchain",
  NEAR: "NEAR blockchain",
  TRX: "Tron blockchain",
  AAVE: "Ethereum blockchain (ERC-20)",
  XTZ: "Tezos blockchain",
  BCH: "Bitcoin Cash blockchain",
  ETC: "Ethereum Classic blockchain",
  DOGE: "Dogecoin blockchain",
  GLMR_GLMR: "Moonbeam blockchain (Polkadot ecosystem)",
  XDC: "XDC blockchain",
  ALGO: "Algorand blockchain",
  APE_ETH: "Ethereum blockchain (ERC-20)",
  GALA2: "Ethereum blockchain (ERC-20)",
  GRT: "Ethereum blockchain (ERC-20)",
  MANA: "Ethereum blockchain (ERC-20)",
  SAND: "Ethereum blockchain (ERC-20)",
  POL: "Ethereum blockchain",
};

const TEST_ASSET_IDS_TO_SECURITY_CODES: Record<string, SecurityCode> = {
  ETH_TEST5: "eth",
  XRP_TEST: "xrp",
  LTC_TEST: "ltc",
  USDC_TEST3: "usdc",
  XLM_TEST: "xlm",
};

export const COINGECKO_IDS: Record<AssetId, string> = {
  BTC: "bitcoin",
  ETH: "ethereum",
  XRP: "ripple",
  LTC: "litecoin",
  EOS: "eos",
  ADA: "cardano",
  AVAX: "avalanche-2",
  COMP: "compound-governance-token",
  DOT: "polkadot",
  KSM: "kusama",
  LINK: "chainlink",
  MATIC: "matic-network",
  SOL: "solana",
  UNI: "uniswap",
  USDC: "usd-coin",
  XLM: "stellar",
  ATOM_COS: "cosmos",
  NEAR: "near",
  TRX: "tron",
  AAVE: "aave",
  XTZ: "tezos",
  BCH: "bitcoin-cash",
  ETC: "ethereum-classic",
  DOGE: "dogecoin",
  GLMR_GLMR: "moonbeam",
  XDC: "xdce-crowd-sale",
  ALGO: "algorand",
  APE_ETH: "apecoin",
  GALA2: "gala",
  GRT: "the-graph",
  MANA: "decentraland",
  SAND: "the-sandbox",
  POL: "polygon-ecosystem-token",
};

// not in use
export const SECURITY_CODE_TO_COINGECKO_ID: Record<
  SecurityCode | SecurityCodeWithoutTransferSupport,
  string
> = {
  btc: "bitcoin",
  eth: "ethereum",
  xrp: "ripple",
  ltc: "litecoin",
  eos: "eos",
  ada: "cardano",
  avax: "avalanche-2",
  comp: "compound-governance-token",
  dot: "polkadot",
  ksm: "kusama",
  link: "chainlink",
  matic: "matic-network",
  sol: "solana",
  uni: "uniswap",
  usdc: "usd-coin",
  xlm: "stellar",
  atom: "cosmos",
  near: "near",
  trx: "tron",
  aave: "aave",
  xtz: "tezos",
  bch: "bitcoin-cash",
  etc: "ethereum-classic",
  doge: "dogecoin",
  glmr: "moonbeam",
  xdc: "xdce-crowd-sale",
  algo: "algorand",
  ape: "apecoin",
  gala: "gala",
  grt: "the-graph",
  mana: "decentraland",
  sand: "the-sandbox",
  apt: "aptos",
  ar: "arweave",
  arb: "arbitrum",
  fil: "filecoin",
  flow: "flow",
  icp: "internet-computer",
  sui: "sui",
  bal: "balancer",
  bat: "basic-attention-token",
  blur: "blur",
  crv: "curve-dao-token",
  hbar: "hedera-hashgraph",
  imx: "immutable-x",
  mkr: "maker",
  qnt: "quant-network",
  snx: "havven",
  yfi: "yearn-finance",
  "1inch": "1inch",
  ach: "alchemy-pay",
  aevo: "aevo-exchange",
  akt: "akash-network",
  ankr: "ankr",
  api3: "api3",
  astr: "astar",
  atlas: "star-atlas",
  audio: "audius",
  axs: "axie-infinity",
  beam: "beam-2",
  bond: "barnbridge",
  bonk: "bonk",
  cfg: "centrifuge",
  chz: "chiliz",
  dydx: "dydx-chain",
  egld: "elrond-erd-2",
  ena: "ethena",
  enj: "enjincoin",
  ens: "ethereum-name-service",
  ethfi: "ether-fi",
  fet: "fetch-ai",
  fida: "bonfida",
  flr: "flare-networks",
  fxs: "frax-share",
  gmx: "gmx",
  gno: "gnosis",
  hft: "hashflow",
  hnt: "helium",
  inj: "injective-protocol",
  jasmy: "jasmycoin",
  jto: "jito-governance-token",
  jup: "jupiter-exchange-solana",
  kava: "kava",
  ldo: "lido-dao",
  lmwr: "limewire-token",
  lpt: "livepeer",
  mina: "mina-protocol",
  mln: "melon",
  movr: "moonriver",
  mpl: "maple",
  nos: "nosana",
  ocean: "ocean-protocol",
  omg: "omisego",
  ondo: "ondo-finance",
  op: "optimism",
  orca: "orca",
  pepe: "pepe",
  perp: "perpetual-protocol",
  pyth: "pyth-network",
  rari: "rarible",
  ray: "raydium",
  ren: "republic-protocol",
  rndr: "render-token",
  rpl: "rocket-pool",
  rune: "thorchain",
  sc: "siacoin",
  sei: "sei-network",
  shib: "shiba-inu",
  strk: "starknet",
  stx: "blockstack",
  super: "superfarm",
  sushi: "sushi",
  tia: "celestia",
  tnsr: "tensor",
  tru: "truefi",
  w: "wormhole",
  waves: "waves",
  wen: "wen4",
  wif: "dogwifcoin",
  zeus: "zeus-network",
  zrx: "0x",
  arkm: "arkham",
  tao: "bittensor",
  btt: "bittorrent",
  cvc: "civic",
  cpool: "clearpool",
  cloud: "sanctum-2",
  drift: "drift-protocol",
  prime: "epik-prime",
  eigen: "eigenlayer",
  ewt: "energy-web-token",
  eurc: "euro-coin",
  eul: "euler",
  floki: "floki",
  gmt: "stepn",
  honey: "hivemapper",
  icx: "icon",
  kmno: "kamino",
  l3: "layer3",
  lrc: "loopring",
  mc: "merit-circle",
  mog: "mog-coin",
  prcl: "parcl",
  pendle: "pendle",
  pol: "polygon-ecosystem-token",
  popcat: "popcat",
  saga: "saga-2",
  scrt: "secret",
  sky: "skycoin",
  stg: "stargate-finance",
  step: "step-finance",
  storj: "storj",
  syn: "synapse-2",
  t: "threshold-network-token",
  turbo: "turbo",
  zeta: "zetachain",
  zex: "zeta",
  zk: "zksync",
  mnt: "mantle",
  ton: "the-open-network",
  syrup: "syrup",
  kas: "kaspa",
  render: "render-token",
  abt: "arcblock",
  aca: "acala",
  ace: "endurance",
  act: "act-i-the-ai-prophecy",
  acx: "across-protocol",
  adx: "adex",
  aergo: "aergo",
  aero: "aerodrome-finance",
  agld: "adventure-gold",
  aioz: "aioz-network",
  aixbt: "aixbt",
  alice: "my-neighbor-alice",
  alpha: "alpha-finance-lab",
  alt: "altlayer",
  amp: "amp-token",
  anime: "anime",
  ark: "ark",
  arpa: "arpa",
  ata: "automata",
  ath: "aethir",
  auction: "auction",
  ava: "concierge-io",
  axl: "axelar",
  baby: "babylon",
  banana: "banana-gun",
  band: "band-protocol",
  bel: "bella-protocol",
  bico: "biconomy",
  bigtime: "big-time",
  bio: "bio-protocol",
  blast: "blast",
  blz: "bluzelle",
  bnb: "binancecoin",
  bnt: "bancor",
  bome: "book-of-meme",
  brett: "based-brett",
  c98: "coin98",
  cake: "pancakeswap-token",
  cati: "catizen",
  celo: "celo",
  celr: "celer-network",
  cetus: "cetus-protocol",
  cfx: "conflux-token",
  chillguy: "chill-guy",
  chr: "chromaway",
  ckb: "nervos-network",
  clv: "clover-finance",
  core: "coredaoorg",
  cos: "contentos",
  coti: "coti",
  cow: "cow-protocol",
  cro: "crypto-com-chain",
  cspr: "casper-network",
  ctc: "creditcoin-2",
  ctk: "certik",
  ctsi: "cartesi",
  cvx: "convex-finance",
  cyber: "cyberconnect",
  d: "dar-open-network",
  data: "streamr",
  dbr: "debridge",
  dcr: "decred",
  deep: "deep",
  degen: "degen-base",
  dent: "dent",
  dgb: "digibyte",
  dia: "dia-data",
  dnt: "district0x",
  dodo: "dodo",
  dogs: "dogs",
  dusk: "dusk-network",
  dym: "dymension",
  edu: "edu-coin",
  elx: "elixir",
  epic: "epic-chain",
  europ: "schuman-europ",
  f: "synfutures",
  fis: "stafi",
  Flux: "zelcash",
  form4: "four",
  forth: "ampleforth-governance-token",
  fueln: "fuel-network",
  g: "g-token",
  gas: "gas",
  ghst: "aavegotchi",
  giga: "gigachad-2",
  glm: "golem",
  gns: "gains-network",
  goat: "goatseus-maximus",
  grass: "grass",
  hei: "heima",
  hifi: "hifi-finance",
  high: "highstreet",
  hmstr: "hamster-kombat",
  hook: "hooked-protocol",
  hot: "holotoken",
  hypel: "hyperliquid",
  id: "space-id",
  idex: "aurora-dao",
  ilv: "illuvium",
  io: "io",
  iost: "iostoken",
  iota: "iota",
  iotx: "iotex",
  ip: "story-2",
  iq: "everipedia",
  jst: "just",
  kaia: "kaia",
  kaito: "kaito",
  kda: "kadena",
  kernel: "kernel-2",
  kmd: "komodo",
  knc: "kyber-network-crystal",
  lista: "lista",
  lqty: "liquity",
  lsk: "lisk",
  lto: "lto-network",
  lumia: "lumia",
  lyx: "lukso-token-2",
  magic: "magic",
  manta: "manta-network",
  mask: "mask-network",
  mav: "maverick-protocol",
  mavia: "heroes-of-mavia",
  mbox: "mobox",
  mdt: "measurable-data-token",
  me: "magic-eden",
  meme: "memecoin-2",
  merl: "merlin-chain",
  metis: "metis-token",
  mew: "cat-in-a-dogs-world",
  michi: "michicoin",
  moca: "mocaverse",
  moodeng: "moo-deng",
  morpho: "morpho",
  move: "movement",
  mtl: "metal",
  nano: "nano",
  neiro: "neiro-3",
  neo: "neo",
  nfp: "nfprompt-token",
  nil: "nillion",
  nkn: "nkn",
  nmr: "numeraire",
  not: "notcoin",
  npc: "non-playable-coin",
  ogn: "origin-protocol",
  om: "mantra-dao",
  omni: "omni-network",
  one: "harmony",
  ong: "ong",
  ont: "ontology",
  ordi: "ordinals",
  osmo: "osmosis",
  oxt: "orchid-protocol",
  parti: "particle-network",
  peaq: "peaq-2",
  pengu: "pudgy-penguins",
  people: "constitutiondao",
  pha: "pha",
  phb: "phoenix-global",
  pixel: "pixels",
  plume: "plume",
  pnut: "peanut-the-squirrel",
  pols: "polkastarter",
  polyx: "polymesh",
  pond: "marlin",
  ponke: "ponke",
  portal: "portal-2",
  powr: "power-ledger",
  prom: "prometeus",
  prompt: "wayfinder",
  puffer: "puffer-finance",
  pundix: "pundi-x-2",
  pyr: "vulcan-forged",
  qkc: "quark-chain",
  qtum: "qtum",
  rad: "radicle",
  rare: "superrare",
  rdnt: "radiant-capital",
  red: "redstone-oracles",
  req: "request-network",
  rez: "renzo",
  rlc: "iexec-rlc",
  ronin: "ronin",
  rose: "oasis-network",
  rsr: "reserve-rights-token",
  rvn: "ravencoin",
  s: "sonic-3",
  safe: "safe",
  scr: "scroll",
  sfp: "safepal",
  skl: "skale",
  slf: "self-chain",
  slp: "smooth-love-potion",
  spx: "spx6900",
  ssv: "ssv-network",
  strax: "stratis",
  sweat: "sweatcoin",
  swell: "swell-network",
  sxp: "swipe",
  tai: "tars-protocol",
  taiko: "taiko",
  the: "thena",
  theta: "theta-token",
  tlm: "alien-worlds",
  token: "tokenfi",
  trac: "origintrail",
  trb: "tellor",
  trumpofficial: "official-trump",
  twt: "trust-wallet-token",
  uma: "uma",
  utk: "xmoney",
  uxlink: "uxlink",
  vana: "vana",
  vanry: "vanar-chain",
  velo: "velo",
  vet: "vechain",
  vic: "tomochain",
  virtual: "virtual-protocol",
  vra: "verasity",
  vtho: "vethor-token",
  wal: "walrus-2",
  waxp: "wax",
  wct: "connect-token-wct",
  win: "wink",
  wld: "worldcoin-wld",
  woo: "woo-network",
  xai: "xai-blockchain",
  xvg: "verge",
  xyo: "xyo-network",
  ygg: "yield-guild-games",
  zen: "zencash",
  zil: "zilliqa",
  zrc: "zircuit",
  zro: "layerzero",
  init: "Initia",
  soph: "Sophon",
  gtc: "Gitcoin",
  fartcoin: "Fartcoin",
  shell: "MyShell",
  a: "Vaulta",
  xion: "Xion",
  sxt: "Space and Time",
  haedal: "Haedal Protocol",
  home: "HOME",
  spk: "Spark",
  newt: "Newton Protocol",
  sign: "Sign",
  icnt: "Impossible Cloud Network Token",
  dmc: "DeLorean",
  huma: "Huma Finance",
  pump: "Pump.fun",
  ika: "Ika",
  tree: "Treehouse",
  sqd: "SQD",
  towns: "Towns",
  prove: "Succinct",
};

export const SECURITY_CODE_TO_ASSET_ID: Record<
  SecurityCodeWithTransfersupport,
  AssetId
> = {
  btc: "BTC",
  eth: "ETH",
  xrp: "XRP",
  ltc: "LTC",
  eos: "EOS",
  ada: "ADA",
  avax: "AVAX",
  comp: "COMP",
  dot: "DOT",
  ksm: "KSM",
  link: "LINK",
  matic: "MATIC",
  sol: "SOL",
  uni: "UNI",
  usdc: "USDC",
  xlm: "XLM",
  atom: "ATOM_COS",
  near: "NEAR",
  trx: "TRX",
  aave: "AAVE",
  xtz: "XTZ",
  bch: "BCH",
  etc: "ETC",
  doge: "DOGE",
  glmr: "GLMR_GLMR",
  xdc: "XDC",
  algo: "ALGO",
  ape: "APE_ETH",
  gala: "GALA2",
  grt: "GRT",
  mana: "MANA",
  sand: "SAND",
  pol: "POL",
};

export const ASSET_NAME_TO_CHAIN_NAME: Record<string, string> = {
  Aave: "Ethereum",
  Cardano: "Cardano",
  Avalanche: "C-Chain",
  Chainlink: "Ethereum",
  Compound: "Ethereum",
  Polygon: "Ethereum",
  Uniswap: "Ethereum",
  USDC: "Ethereum",
  POL: "Ethereum",
};
// FA name to FA security code
export const NAME_TO_SECURITY_CODE: Record<
  string,
  SecurityCode | SecurityCodeWithoutTransferSupport
> = {
  Bitcoin: "btc",
  Ethereum: "eth",
  XRP: "xrp",
  Litecoin: "ltc",
  EOS: "eos",
  Cardano: "ada",
  Avalanche: "avax",
  Compound: "comp",
  Polkadot: "dot",
  Kusama: "ksm",
  Chainlink: "link",
  Polygon: "matic",
  Solana: "sol",
  Uniswap: "uni",
  USDC: "usdc",
  Stellar: "xlm",
  Cosmos: "atom",
  "NEAR Protocol": "near",
  TRON: "trx",
  Aave: "aave",
  Tezos: "xtz",
  "Bitcoin Cash": "bch",
  "Ethereum Classic": "etc",
  Dogecoin: "doge",
  Moonbeam: "glmr",
  "XDC Network": "xdc",
  Algorand: "algo",
  ApeCoin: "ape",
  GALA: "gala",
  "The Graph": "grt",
  Decentraland: "mana",
  "The Sandbox": "sand",
  Aptos: "apt",
  Arweave: "ar",
  Arbitrum: "arb",
  Balancer: "bal",
  "Basic Attention": "bat",
  Blur: "blur",
  "Curve DAO": "crv",
  Filecoin: "fil",
  Flow: "flow",
  Hedera: "hbar",
  "Internet Computer": "icp",
  Immutable: "imx",
  Maker: "mkr",
  Quant: "qnt",
  "Synthetix Network": "snx",
  Sui: "sui",
  "Yearn Finance": "yfi",
  "1inch": "1inch",
  "Alchemy Pay": "ach",
  Aevo: "aevo",
  "Akash Network": "akt",
  "Ankr Network": "ankr",
  API3: "api3",
  Astar: "astr",
  "Star Atlas": "atlas",
  Audius: "audio",
  "Axie Infinity": "axs",
  Beam: "beam",
  BarnBridge: "bond",
  Bonk: "bonk",
  Centrifuge: "cfg",
  Chiliz: "chz",
  dYdX: "dydx",
  MultiversX: "egld",
  Ethena: "ena",
  "Enjin Coin": "enj",
  "Ethereum Name Service": "ens",
  "Ether.fi": "ethfi",
  "Fetch.ai": "fet",
  Bonfida: "fida",
  Flare: "flr",
  "Frax Share": "fxs",
  GMX: "gmx",
  Gnosis: "gno",
  Hashflow: "hft",
  Helium: "hnt",
  Injective: "inj",
  JasmyCoin: "jasmy",
  Jito: "jto",
  Jupiter: "jup",
  Kava: "kava",
  "Lido DAO": "ldo",
  LimeWire: "lmwr",
  Livepeer: "lpt",
  "Mina Protocol": "mina",
  Enzyme: "mln",
  Moonriver: "movr",
  Maple: "mpl",
  Nosana: "nos",
  "Ocean Protocol": "ocean",
  "OMG Network": "omg",
  Ondo: "ondo",
  Optimism: "op",
  Orca: "orca",
  Pepe: "pepe",
  "Perpetual Protocol": "perp",
  "Pyth Network": "pyth",
  RARI: "rari",
  Raydium: "ray",
  Ren: "ren",
  Render: "rndr",
  "Rocket Pool": "rpl",
  THORChain: "rune",
  Siacoin: "sc",
  Sei: "sei",
  "Shiba Inu": "shib",
  Starknet: "strk",
  Stacks: "stx",
  SuperVerse: "super",
  Sushi: "sushi",
  Celestia: "tia",
  Tensor: "tnsr",
  TrueFi: "tru",
  Wormhole: "w",
  Waves: "waves",
  Wen: "wen",
  dogwifhat: "wif",
  "Zeus Network": "zeus",
  "0x Protocol": "zrx",
  Arkham: "arkm",
  Bittensor: "tao",
  BitTorrent: "btt",
  Civic: "cvc",
  Clearpool: "cpool",
  Cloud: "cloud",
  "Drift Protocol": "drift",
  "Echelon Prime": "prime",
  Eigenlayer: "eigen",
  "Energy Web": "ewt",
  EURC: "eurc",
  Euler: "eul",
  FLOKI: "floki",
  GMT: "gmt",
  Hivemapper: "honey",
  ICON: "icx",
  Kamino: "kmno",
  Layer3: "l3",
  Loopring: "lrc",
  "Merit Circle": "mc",
  "Mog Coin": "mog",
  Parcl: "prcl",
  Pendle: "pendle",
  "POL (ex-MATIC)": "pol",
  Popcat: "popcat",
  Saga: "saga",
  Secret: "scrt",
  Sky: "sky",
  "Stargate Finance": "stg",
  "Step Finance": "step",
  Storj: "storj",
  Synapse: "syn",
  "Threshold Network": "t",
  Turbo: "turbo",
  ZetaChain: "zeta",
  Zeta: "zex",
  ZKsync: "zk",
  Mantle: "mnt",
  Toncoin: "ton",
  Syrup: "syrup",
  Kaspa: "kas",
  "Render (SOL)": "render",
  Arcblock: "abt",
  Acala: "aca",
  Fusionist: "ace",
  "Act I The AI Prophecy": "act",
  "Across Protocol": "acx",
  AdEx: "adx",
  Aergo: "aergo",
  "Aerodrome Finance": "aero",
  "Adventure Gold": "agld",
  "AIOZ Network": "aioz",
  "aixbt by Virtuals": "aixbt",
  "My Neighbor Alice": "alice",
  Stella: "alpha",
  AltLayer: "alt",
  Amp: "amp",
  Animecoin: "anime",
  ARK: "ark",
  ARPA: "arpa",
  Automata: "ata",
  Aethir: "ath",
  Bounce: "auction",
  "AVA (Travala)": "ava",
  Axelar: "axl",
  Babylon: "baby",
  "Banana Gun": "banana",
  "Band Protocol": "band",
  "Bella Protocol": "bel",
  Biconomy: "bico",
  "Big Time": "bigtime",
  "Bio Protocol": "bio",
  Blast: "blast",
  Bluzelle: "blz",
  BNB: "bnb",
  "Bancor Network": "bnt",
  "BOOK OF MEME": "bome",
  Brett: "brett",
  Coin98: "c98",
  PancakeSwap: "cake",
  Catizen: "cati",
  Celo: "celo",
  "Celer Network": "celr",
  "Cetus Protocol": "cetus",
  Conflux: "cfx",
  "Just a chill guy": "chillguy",
  Chromia: "chr",
  "Nervos Network": "ckb",
  "Clover Finance": "clv",
  Core: "core",
  Contentos: "cos",
  COTI: "coti",
  "CoW Protocol": "cow",
  Cronos: "cro",
  "Casper Network": "cspr",
  Creditcoin: "ctc",
  Shentu: "ctk",
  Cartesi: "ctsi",
  "Convex Finance": "cvx",
  CYBER: "cyber",
  "Dar Open Network": "d",
  Streamr: "data",
  deBridge: "dbr",
  Decred: "dcr",
  DeepBook: "deep",
  Degen: "degen",
  Dent: "dent",
  DigiByte: "dgb",
  DIA: "dia",
  district0x: "dnt",
  DODO: "dodo",
  Dogs: "dogs",
  DUSK: "dusk",
  Dymension: "dym",
  "Open Campus": "edu",
  Elixir: "elx",
  "Epic Chain": "epic",
  EURØP: "europ",
  SynFutures: "f",
  Stafi: "fis",
  Flux: "Flux",
  Four: "form4",
  "Ampleforth Governance": "forth",
  Fuel: "fueln",
  Gravity: "g",
  Gas: "gas",
  Aavegotchi: "ghst",
  Gigachad: "giga",
  Golem: "glm",
  "Gains Network": "gns",
  "Goatseus Maximus": "goat",
  Grass: "grass",
  Heima: "hei",
  "Hifi Finance": "hifi",
  Highstreet: "high",
  "Hamster Kombat": "hmstr",
  "Hooked Protocol": "hook",
  Holo: "hot",
  Hyperliquid: "hypel",
  "SPACE ID": "id",
  IDEX: "idex",
  Illuvium: "ilv",
  "io.net": "io",
  IOST: "iost",
  IOTA: "iota",
  IoTeX: "iotx",
  Story: "ip",
  IQ: "iq",
  JUST: "jst",
  Kaia: "kaia",
  KAITO: "kaito",
  Kadena: "kda",
  KernelDAO: "kernel",
  Komodo: "kmd",
  "Kyber Network Crystal": "knc",
  "Lista DAO": "lista",
  Liquity: "lqty",
  Lisk: "lsk",
  "LTO Network": "lto",
  Lumia: "lumia",
  LUKSO: "lyx",
  Treasure: "magic",
  "Manta Network": "manta",
  "Mask Network": "mask",
  "Maverick Protocol": "mav",
  "Heroes of Mavia": "mavia",
  Mobox: "mbox",
  "Measurable Data": "mdt",
  "Magic Eden": "me",
  Memecoin: "meme",
  "Merlin Chain": "merl",
  Metis: "metis",
  "cat in a dogs world": "mew",
  michi: "michi",
  "Moca Network": "moca",
  "Moo Deng": "moodeng",
  Morpho: "morpho",
  Movement: "move",
  "Metal DAO": "mtl",
  Nano: "nano",
  Neiro: "neiro",
  NEO: "neo",
  NFPrompt: "nfp",
  Nillion: "nil",
  NKN: "nkn",
  Numeraire: "nmr",
  Notcoin: "not",
  "Non-Playable Coin": "npc",
  "Origin Token": "ogn",
  MANTRA: "om",
  "Omni Network": "omni",
  Harmony: "one",
  "Ontology Gas": "ong",
  Ontology: "ont",
  ORDI: "ordi",
  Osmosis: "osmo",
  "Orchid Protocol": "oxt",
  "Particle Network": "parti",
  peaq: "peaq",
  "Pudgy Penguins": "pengu",
  ConstitutionDAO: "people",
  PHALA: "pha",
  Phoenix: "phb",
  Pixels: "pixel",
  Plume: "plume",
  "Peanut the Squirrel": "pnut",
  Polkastarter: "pols",
  Polymesh: "polyx",
  Marlin: "pond",
  PONKE: "ponke",
  Portal: "portal",
  Powerledger: "powr",
  Prom: "prom",
  Wayfinder: "prompt",
  Puffer: "puffer",
  "Pundi X": "pundix",
  "Vulcan Forged": "pyr",
  QuarkChain: "qkc",
  Qtum: "qtum",
  Radworks: "rad",
  SuperRare: "rare",
  "Radiant Capital": "rdnt",
  RedStone: "red",
  Request: "req",
  Renzo: "rez",
  "iExec RLC": "rlc",
  Ronin: "ronin",
  Oasis: "rose",
  "Reserve Rights": "rsr",
  Ravencoin: "rvn",
  Sonic: "s",
  Safe: "safe",
  Scroll: "scr",
  SafePal: "sfp",
  SKALE: "skl",
  "Self Chain": "slf",
  "Smooth Love Potion": "slp",
  SPX6900: "spx",
  "SSV Network": "ssv",
  Stratis: "strax",
  Sweat: "sweat",
  Swell: "swell",
  Solar: "sxp",
  "TARS AI": "tai",
  Taiko: "taiko",
  Thena: "the",
  "Theta Network": "theta",
  "Alien Worlds": "tlm",
  TokenFi: "token",
  OriginTrail: "trac",
  "Tellor Tributes": "trb",
  "Official Trump": "trumpofficial",
  "Trust Wallet": "twt",
  UMA: "uma",
  xMoney: "utk",
  UXLINK: "uxlink",
  Vana: "vana",
  "Vanar Chain": "vanry",
  Velo: "velo",
  VeChain: "vet",
  Viction: "vic",
  "Virtuals Protocol": "virtual",
  Verasity: "vra",
  VeThor: "vtho",
  Walrus: "wal",
  WAX: "waxp",
  "WalletConnect Token": "wct",
  WINkLink: "win",
  Worldcoin: "wld",
  WOO: "woo",
  Xai: "xai",
  Verge: "xvg",
  "XYO Network": "xyo",
  "Yield Guild Games": "ygg",
  Horizen: "zen",
  Zilliqa: "zil",
  Zircuit: "zrc",
  LayerZero: "zro",
  Initia: "init",
  Sophon: "soph",
  Gitcoin: "gtc",
  Fartcoin: "fartcoin",
  MyShell: "shell",
  Vaulta: "a",
  Xion: "xion",
  "Space and Time": "sxt",
  "Haedal Protocol": "haedal",
  HOME: "home",
  Spark: "spk",
  "Newton Protocol": "newt",
  Sign: "sign",
  "Impossible Cloud Network Token": "icnt",
  DeLorean: "dmc",
  "Huma Finance": "huma",
  "Pump.fun": "pump",
  Ika: "ika",
  Treehouse: "tree",
  SQD: "sqd",
  Towns: "towns",
  Succinct: "prove",
};

export const SECURITY_CODE_TO_COINBASE_ID: Record<
  SecurityCode | SecurityCodeWithoutTransferSupport,
  string
> = {
  aave: "COINBASE:AAVEEUR",
  avax: "COINBASE:AVAXEUR",
  btc: "COINBASE:BTCEUR",
  ada: "COINBASE:ADAEUR",
  link: "COINBASE:LINKEUR",
  comp: "KRAKEN:COMPEUR",
  atom: "COINBASE:ATOMEUR",
  eos: "COINBASE:EOSEUR",
  eth: "COINBASE:ETHEUR",
  ksm: "KRAKEN:KSMEUR",
  ltc: "COINBASE:LTCEUR",
  near: "KRAKEN:NEAREUR",
  dot: "COINBASE:DOTEUR",
  matic: "COINBASE:MATICEUR",
  sol: "COINBASE:SOLEUR",
  xlm: "COINBASE:XLMEUR",
  xtz: "COINBASE:XTZEUR",
  trx: "KRAKEN:TRXEUR",
  uni: "COINBASE:UNIEUR",
  usdc: "COINBASE:USDCEUR",
  xrp: "KRAKEN:XRPEUR",
  etc: "COINBASE:ETCEUR",
  bch: "COINBASE:BCHEUR",
  doge: "COINBASE:DOGEEUR",
  glmr: "KRAKEN:GLMREUR",
  xdc: "BITVAVO:XDCEUR",
  algo: "COINBASE:ALGOEUR",
  ape: "COINBASE:APEEUR",
  gala: "KRAKEN:GALAEUR",
  grt: "COINBASE:GRTEUR",
  mana: "COINBASE:MANAEUR",
  sand: "KRAKEN:SANDEUR",
  apt: "KRAKEN:APTEUR",
  ar: "BITTREX:ARBTC",
  arb: "KRAKEN:ARBEUR",
  fil: "COINBASE:FILEUR",
  flow: "KRAKEN:FLOWEUR",
  icp: "COINBASE:ICPEUR",
  sui: "KRAKEN:SUIEUR",
  bal: "KRAKEN:BALEUR",
  bat: "COINBASE:BATEUR",
  blur: "KRAKEN:BLUREUR",
  crv: "COINBASE:CRVEUR",
  hbar: "BITSTAMP:HBAREUR",
  imx: "KRAKEN:IMXEUR",
  mkr: "KRAKEN:MKREUR",
  qnt: "KRAKEN:QNTEUR",
  snx: "COINBASE:SNXEUR",
  yfi: "KRAKEN:YFIEUR",
  "1inch": "CRYPTO:1INCHUSD",
  ach: "CRYPTO:ACHUSD",
  aevo: "CRYPTO:AEVOUSD",
  akt: "CRYPTO:AKTUSD",
  ankr: "CRYPTO:ANKRUSD",
  api3: "CRYPTO:API3USD",
  astr: "CRYPTO:ASTRUSD",
  atlas: "CRYPTO:ATLASUSD",
  audio: "CRYPTO:AUDIOUSD",
  axs: "CRYPTO:AXSUSD",
  beam: "KRAKEN:BEAMEUR",
  bond: "CRYPTO:BONDUSD",
  bonk: "CRYPTO:BONKUSD",
  cfg: "CRYPTO:CFGUSD",
  chz: "CRYPTO:CHZUSD",
  dydx: "CRYPTO:DYDXUSD",
  egld: "CRYPTO:EGLDUSD",
  ena: "CRYPTO:ENAUSD",
  enj: "CRYPTO:ENJUSD",
  ens: "CRYPTO:ENSUSD",
  ethfi: "CRYPTO:ETHFIUSD",
  fet: "CRYPTO:FETUSD",
  fida: "CRYPTO:FIDAUSD",
  flr: "CRYPTO:FLRUSD",
  fxs: "CRYPTO:FXSUSD",
  gmx: "CRYPTO:GMXUSD",
  gno: "CRYPTO:GNOUSD",
  hft: "CRYPTO:HFTUSD",
  hnt: "CRYPTO:HNTUSD",
  inj: "CRYPTO:INJUSD",
  jasmy: "CRYPTO:JASMYUSD",
  jto: "CRYPTO:JTOUSD",
  jup: "KRAKEN:JUPEUR",
  kava: "CRYPTO:KAVAUSD",
  ldo: "CRYPTO:LDOUSD",
  lmwr: "CRYPTO:LMWRUSD",
  lpt: "CRYPTO:LPTUSD",
  mina: "CRYPTO:MINAUSD",
  mln: "CRYPTO:MLNUSD",
  movr: "CRYPTO:MOVRUSD",
  mpl: "CRYPTO:MPLUSD",
  nos: "CRYPTO:NOSUSD",
  ocean: "CRYPTO:OCEANUSD",
  omg: "CRYPTO:OMGUSD",
  ondo: "CRYPTO:ONDOUSD",
  op: "CRYPTO:OPUSD",
  orca: "CRYPTO:ORCAUSD",
  pepe: "CRYPTO:PEPEUSD",
  perp: "CRYPTO:PERPUSD",
  pyth: "CRYPTO:PYTHUSD",
  rari: "CRYPTO:RARIUSD",
  ray: "CRYPTO:RAYUSD",
  ren: "CRYPTO:RENUSD",
  rndr: "CRYPTO:RNDRUSD",
  rpl: "CRYPTO:RPLUSD",
  rune: "CRYPTO:RUNEUSD",
  sc: "CRYPTO:SCUSD",
  sei: "CRYPTO:SEIUSD",
  shib: "CRYPTO:SHIBUSD",
  strk: "KRAKEN:STRKEUR",
  stx: "CRYPTO:STXSUSD",
  super: "CRYPTO:SUPERUSD",
  sushi: "CRYPTO:SUSHIUSD",
  tia: "CRYPTO:TIA2USD",
  tnsr: "CRYPTO:TNSRUSD",
  tru: "CRYPTO:TRUUSD",
  w: "CRYPTO:WUSD",
  waves: "CRYPTO:WAVESUSD",
  wen: "KRAKEN:WENEUR",
  wif: "CRYPTO:WIFUSD",
  zeus: "KRAKEN:ZEUSUSD",
  zrx: "CRYPTO:ZRXUSD",
  arkm: "KRAKEN:ARKMEUR",
  tao: "KRAKEN:TAOEUR",
  btt: "KRAKEN:BTTEUR",
  cvc: "KRAKEN:CVCEUR",
  cpool: "KRAKEN:CPOOLEUR",
  cloud: "KRAKEN:CLOUDEUR",
  drift: "KRAKEN:DRIFTEUR",
  prime: "KRAKEN:PRIMEEUR",
  eigen: "KRAKEN:EIGENEUR",
  ewt: "KRAKEN:EWTEUR",
  eurc: "BITSTAMP:EUROCEUR",
  eul: "KRAKEN:EULEUR",
  floki: "KRAKEN:FLOKIEUR",
  gmt: "KRAKEN:GMTEUR",
  honey: "KRAKEN:HONEYEUR",
  icx: "KRAKEN:ICXEUR",
  kmno: "KRAKEN:KMNOEUR",
  l3: "KRAKEN:L3EUR",
  lrc: "KRAKEN:LRCEUR",
  mc: "KRAKEN:MCEUR",
  mog: "KRAKEN:MOGEUR",
  prcl: "KRAKEN:PRCLEUR",
  pendle: "KRAKEN:PENDLEEUR",
  pol: "KRAKEN:POLEUR",
  popcat: "KRAKEN:POPCATEUR",
  saga: "KRAKEN:SAGAEUR",
  scrt: "KRAKEN:SCRTEUR",
  sky: "KRAKEN:SKYEUR",
  stg: "KRAKEN:STGEUR",
  step: "KRAKEN:STEPEUR",
  storj: "KRAKEN:STORJEUR",
  syn: "KRAKEN:SYNEUR",
  t: "KRAKEN:TEUR",
  turbo: "KRAKEN:TURBOEUR",
  zeta: "KRAKEN:ZETAEUR",
  zex: "KRAKEN:ZEXEUR",
  zk: "KRAKEN:ZKEUR",
  mnt: "KRAKEN:MNTEUR",
  ton: "KRAKEN:TONEUR",
  syrup: "KRAKEN:SYRUPEUR",
  kas: "KRAKEN:KASEUR",
  render: "KRAKEN:RENDEREUR",
  abt: "BITVAVO:ABTEUR",
  aca: "BITVAVO:ACAEUR",
  ace: "BITVAVO:ACEEUR",
  act: "BITVAVO:ACTSOLEUR",
  acx: "BITVAVO:ACXEUR",
  adx: "BITVAVO:ADXEUR",
  aergo: "BITVAVO:AERGOEUR",
  aero: "BITVAVO:AEROEUR",
  agld: "BITVAVO:AGLDEUR",
  aioz: "BITVAVO:AIOZEUR",
  aixbt: "BITVAVO:AIXBTEUR",
  alice: "BITVAVO:ALICEEUR",
  alpha: "BITVAVO:ALPHAEUR",
  alt: "BITVAVO:ALTEUR",
  amp: "BITVAVO:AMPEUR",
  anime: "BITVAVO:ANIMEEUR",
  ark: "BITVAVO:ARKEUR",
  arpa: "BITVAVO:ARPAEUR",
  ata: "BITVAVO:ATAEUR",
  ath: "BITVAVO:ATHEUR",
  auction: "BITVAVO:AUCTIONEUR",
  ava: "BITVAVO:AVAEUR",
  axl: "BITVAVO:AXLEUR",
  baby: "BITVAVO:BABYEUR",
  banana: "BITVAVO:BANANAEUR",
  band: "BITVAVO:BANDEUR",
  bel: "BITVAVO:BELEUR",
  bico: "BITVAVO:BICOEUR",
  bigtime: "BITVAVO:BIGTIMEEUR",
  bio: "BITVAVO:BIOEUR",
  blast: "BITVAVO:BLASTEUR",
  blz: "BITVAVO:BLZEUR",
  bnb: "BITVAVO:BNBEUR",
  bnt: "BITVAVO:BNTEUR",
  bome: "BITVAVO:BOMEEUR",
  brett: "BITVAVO:BRETTEUR",
  c98: "BITVAVO:C98EUR",
  cake: "BITVAVO:CAKEEUR",
  cati: "BITVAVO:CATIEUR",
  celo: "BITVAVO:CELOEUR",
  celr: "BITVAVO:CELREUR",
  cetus: "BITVAVO:CETUSEUR",
  cfx: "BITVAVO:CFXEUR",
  chillguy: "BITVAVO:CHILLGUYEUR",
  chr: "BITVAVO:CHREUR",
  ckb: "BITVAVO:CKBEUR",
  clv: "BITVAVO:CLVEUR",
  core: "BITVAVO:COREEUR",
  cos: "BITVAVO:COSEUR",
  coti: "BITVAVO:COTIEUR",
  cow: "BITVAVO:COWEUR",
  cro: "BITVAVO:CROEUR",
  cspr: "BITVAVO:CSPREUR",
  ctc: "BITVAVO:CTCEUR",
  ctk: "BITVAVO:CTKEUR",
  ctsi: "BITVAVO:CTSIEUR",
  cvx: "BITVAVO:CVXEUR",
  cyber: "BITVAVO:CYBEREUR",
  d: "BITVAVO:DEUR",
  data: "BITVAVO:DATAEUR",
  dbr: "BITVAVO:DBREUR",
  dcr: "BITVAVO:DCREUR",
  deep: "BITVAVO:DEEPEUR",
  degen: "BITVAVO:DEGENEUR",
  dent: "BITVAVO:DENTEUR",
  dgb: "BITVAVO:DGBEUR",
  dia: "BITVAVO:DIAEUR",
  dnt: "BITVAVO:DNTEUR",
  dodo: "BITVAVO:DODOEUR",
  dogs: "BITVAVO:DOGSEUR",
  dusk: "BITVAVO:DUSKEUR",
  dym: "BITVAVO:DYMEUR",
  edu: "BITVAVO:EDUEUR",
  elx: "BITVAVO:ELXEUR",
  epic: "BITVAVO:EPICEUR",
  europ: "BITVAVO:EUROPEUR",
  f: "BITVAVO:FEUR",
  fis: "BITVAVO:FISEUR",
  Flux: "BITVAVO:FLUXEUR",
  form4: "BITVAVO:FORM4EUR",
  forth: "BITVAVO:FORTHEUR",
  fueln: "BITVAVO:FUELNEUR",
  g: "BITVAVO:GEUR",
  gas: "BITVAVO:GASEUR",
  ghst: "BITVAVO:GHSTEUR",
  giga: "BITVAVO:GIGAEUR",
  glm: "BITVAVO:GLMEUR",
  gns: "BITVAVO:GNSEUR",
  goat: "BITVAVO:GOATEUR",
  grass: "BITVAVO:GRASSEUR",
  hei: "BITVAVO:HEIEUR",
  hifi: "BITVAVO:HIFIEUR",
  high: "BITVAVO:HIGHEUR",
  hmstr: "BITVAVO:HMSTREUR",
  hook: "BITVAVO:HOOKEUR",
  hot: "BITVAVO:HOTEUR",
  hypel: "BITVAVO:HYPELEUR",
  id: "BITVAVO:IDEUR",
  idex: "BITVAVO:IDEXEUR",
  ilv: "BITVAVO:ILVEUR",
  io: "BITVAVO:IOEUR",
  iost: "BITVAVO:IOSTEUR",
  iota: "BITVAVO:IOTAEUR",
  iotx: "BITVAVO:IOTXEUR",
  ip: "BITVAVO:IPEUR",
  iq: "BITVAVO:IQEUR",
  jst: "BITVAVO:JSTEUR",
  kaia: "BITVAVO:KAIAEUR",
  kaito: "BITVAVO:KAITOEUR",
  kda: "BITVAVO:KDAEUR",
  kernel: "BITVAVO:KERNELEUR",
  kmd: "BITVAVO:KMDEUR",
  knc: "BITVAVO:KNCEUR",
  lista: "BITVAVO:LISTAEUR",
  lqty: "BITVAVO:LQTYEUR",
  lsk: "BITVAVO:LSKEUR",
  lto: "BITVAVO:LTOEUR",
  lumia: "BITVAVO:LUMIAEUR",
  lyx: "BITVAVO:LYXEUR",
  magic: "BITVAVO:MAGICEUR",
  manta: "BITVAVO:MANTAEUR",
  mask: "BITVAVO:MASKEUR",
  mav: "BITVAVO:MAVEUR",
  mavia: "BITVAVO:MAVIAEUR",
  mbox: "BITVAVO:MBOXEUR",
  mdt: "BITVAVO:MDTEUR",
  me: "BITVAVO:MEEUR",
  meme: "BITVAVO:MEMEEUR",
  merl: "BITVAVO:MERLEUR",
  metis: "BITVAVO:METISEUR",
  mew: "BITVAVO:MEWEUR",
  michi: "BITVAVO:MICHIEUR",
  moca: "BITVAVO:MOCAEUR",
  moodeng: "BITVAVO:MOODENGEUR",
  morpho: "BITVAVO:MORPHOEUR",
  move: "BITVAVO:MOVEEUR",
  mtl: "BITVAVO:MTLEUR",
  nano: "BITVAVO:NANOEUR",
  neiro: "BITVAVO:NEIROEUR",
  neo: "BITVAVO:NEOEUR",
  nfp: "BITVAVO:NFPEUR",
  nil: "BITVAVO:NILEUR",
  nkn: "BITVAVO:NKNEUR",
  nmr: "BITVAVO:NMREUR",
  not: "BITVAVO:NOTEUR",
  npc: "BITVAVO:NPCEUR",
  ogn: "BITVAVO:OGNEUR",
  om: "BITVAVO:OMEUR",
  omni: "BITVAVO:OMNIEUR",
  one: "BITVAVO:ONEEUR",
  ong: "BITVAVO:ONGEUR",
  ont: "BITVAVO:ONTEUR",
  ordi: "BITVAVO:ORDIEUR",
  osmo: "BITVAVO:OSMOEUR",
  oxt: "BITVAVO:OXTEUR",
  parti: "BITVAVO:PARTIEUR",
  peaq: "BITVAVO:PEAQEUR",
  pengu: "BITVAVO:PENGUEUR",
  people: "BITVAVO:PEOPLEEUR",
  pha: "BITVAVO:PHAEUR",
  phb: "BITVAVO:PHBEUR",
  pixel: "BITVAVO:PIXELEUR",
  plume: "BITVAVO:PLUMEEUR",
  pnut: "BITVAVO:PNUTEUR",
  pols: "BITVAVO:POLSEUR",
  polyx: "BITVAVO:POLYXEUR",
  pond: "BITVAVO:PONDEUR",
  ponke: "BITVAVO:PONKEEUR",
  portal: "BITVAVO:PORTALEUR",
  powr: "BITVAVO:POWREUR",
  prom: "BITVAVO:PROMEUR",
  prompt: "BITVAVO:PROMPTEUR",
  puffer: "BITVAVO:PUFFEREUR",
  pundix: "BITVAVO:PUNDIXEUR",
  pyr: "BITVAVO:PYREUR",
  qkc: "BITVAVO:QKCEUR",
  qtum: "BITVAVO:QTUMEUR",
  rad: "BITVAVO:RADEUR",
  rare: "BITVAVO:RAREEUR",
  rdnt: "BITVAVO:RDNTEUR",
  red: "BITVAVO:REDEUR",
  req: "BITVAVO:REQEUR",
  rez: "BITVAVO:REZEUR",
  rlc: "BITVAVO:RLCEUR",
  ronin: "BITVAVO:RONINEUR",
  rose: "BITVAVO:ROSEEUR",
  rsr: "BITVAVO:RSREUR",
  rvn: "BITVAVO:RVNEUR",
  s: "BITVAVO:SEUR",
  safe: "BITVAVO:SAFEEUR",
  scr: "BITVAVO:SCREUR",
  sfp: "BITVAVO:SFPEUR",
  skl: "BITVAVO:SKLEUR",
  slf: "BITVAVO:SLFEUR",
  slp: "BITVAVO:SLPEUR",
  spx: "BITVAVO:SPXEUR",
  ssv: "BITVAVO:SSVEUR",
  strax: "BITVAVO:STRAXEUR",
  sweat: "BITVAVO:SWEATEUR",
  swell: "BITVAVO:SWELLEUR",
  sxp: "BITVAVO:SXPEUR",
  tai: "BITVAVO:TAIEUR",
  taiko: "BITVAVO:TAIKOEUR",
  the: "BITVAVO:THEEUR",
  theta: "BITVAVO:THETAEUR",
  tlm: "BITVAVO:TLMEUR",
  token: "BITVAVO:TOKENEUR",
  trac: "BITVAVO:TRACEUR",
  trb: "BITVAVO:TRBEUR",
  trumpofficial: "BITVAVO:TRUMPEUR",
  twt: "BITVAVO:TWTEUR",
  uma: "BITVAVO:UMAEUR",
  utk: "BITVAVO:UTKEUR",
  uxlink: "BITVAVO:UXLINKEUR",
  vana: "BITVAVO:VANAEUR",
  vanry: "BITVAVO:VANRYEUR",
  velo: "BITVAVO:VELOEUR",
  vet: "BITVAVO:VETEUR",
  vic: "BITVAVO:VICEUR",
  virtual: "BITVAVO:VIRTUALEUR",
  vra: "BITVAVO:VRAEUR",
  vtho: "BITVAVO:VTHOEUR",
  wal: "BITVAVO:WALEUR",
  waxp: "BITVAVO:WAXPEUR",
  wct: "BITVAVO:WCTEUR",
  win: "BITVAVO:WINEUR",
  wld: "BITVAVO:WLDEUR",
  woo: "BITVAVO:WOOEUR",
  xai: "BITVAVO:XAIEUR",
  xvg: "BITVAVO:XVGEUR",
  xyo: "BITVAVO:XYOEUR",
  ygg: "BITVAVO:YGGEUR",
  zen: "BITVAVO:ZENEUR",
  zil: "BITVAVO:ZILEUR",
  zrc: "BITVAVO:ZRCEUR",
  zro: "BITVAVO:ZROEUR",
  init: "BITVAVO:INITEUR",
  soph: "BITVAVO:SOPHEUR",
  gtc: "BITVAVO:GTCEUR",
  fartcoin: "BITVAVO:FARTCOINEUR",
  shell: "BITVAVO:SHELLEUR",
  a: "BITVAVO:AEUR",
  xion: "BITVAVO:XIONEUR",
  sxt: "BITVAVO:SXTEUR",
  haedal: "BITVAVO:HAEDALEUR",
  home: "BITVAVO:HOMEEUR",
  spk: "BITVAVO:SPKEUR",
  newt: "BITVAVO:NEWTEUR",
  sign: "BITVAVO:SIGNEUR",
  icnt: "BITVAVO:ICNTEUR",
  dmc: "BITVAVO:DMCEUR",
  huma: "BITVAVO:HUMAEUR",
  pump: "BITVAVO:PUMPEUR",
  ika: "BITVAVO:IKAEUR",
  tree: "BITVAVO:TREEEUR",
  sqd: "BITVAVO:SQDEUR",
  towns: "BITVAVO:TOWNSEUR",
  prove: "BITVAVO:PROVEEUR",
};

/**
 * THESE EXPORTS ARE USED FOR TRANSFERS SINCE WE ALLOW A DIFFERENT LIST OF ASSETS FOR TEST / DEV MODE
 */

export const isDevelopment =
  process.env.REACT_APP_WALLETS_API_URL?.includes("dev");

// TODO: add support back for USDC
export const TEST_VALID_SECURITY_CODES: SecurityCode[] = [
  "eth",
  "xrp",
  "ltc",
  "xlm",
];

export const transferrableAssetIdsToSecurityCodes: Record<
  string,
  SecurityCode
> = isDevelopment
  ? TEST_ASSET_IDS_TO_SECURITY_CODES
  : ASSET_ID_TO_SECURITY_CODE;

export const transferrableSecurityCodes = isDevelopment
  ? TEST_VALID_SECURITY_CODES
  : VALID_SECURITY_CODES_WITH_TRANSFER_SUPPORT;

export const transferrableSecurities = isDevelopment
  ? TEST_VALID_SECURITY_CODES
  : VALID_ASSET_IDS;

export const convertSecurityCodeSekToSecurityCode = (
  securityCodeSek: SecurityCodeSek
): SecurityCode => {
  const securityCode = securityCodeSek.replace("sek", "") as SecurityCode;
  if (VALID_SECURITY_CODES.includes(securityCode)) {
    return securityCode;
  }
  throw new Error(`Invalid SecurityCodeSek: ${securityCodeSek}`);
};

// FA security code
export const LIMIT_ORDER_ONLY_SECURITIES: Set<
  SecurityCode | SecurityCodeWithoutTransferSupport
> = new Set([
  "1inch",
  "ach",
  "aevo",
  "akt",
  "ankr",
  "api3",
  "astr",
  "atlas",
  "audio",
  "axs",
  "beam",
  "bond",
  "bonk",
  "cfg",
  "chz",
  "egld",
  "ena",
  "enj",
  "ens",
  "ethfi",
  "fet",
  "fida",
  "flr",
  "fxs",
  "gmx",
  "gno",
  "hft",
  "hnt",
  "inj",
  "jasmy",
  "jto",
  "jup",
  "kava",
  "ldo",
  "lmwr",
  "lpt",
  "mina",
  "mln",
  "movr",
  "mpl",
  "nos",
  "ocean",
  "omg",
  "ondo",
  "orca",
  "perp",
  "pyth",
  "rari",
  "ray",
  "rpl",
  "rune",
  "sc",
  "sei",
  "stx",
  "super",
  "tia",
  "tnsr",
  "tru",
  "w",
  "waves",
  "wen",
  "wif",
  "zeus",
  "zrx",
  "dydx",
  "op",
  "pepe",
  "ren",
  "rndr",
  "shib",
  "strk",
  "sushi",
  "arkm",
  "btt",
  "cvc",
  "cpool",
  "drift",
  "prime",
  "eigen",
  "ewt",
  "eul",
  "floki",
  "gmt",
  "honey",
  "icx",
  "kmno",
  "l3",
  "lrc",
  "mc",
  "mog",
  "prcl",
  "pendle",
  "popcat",
  "saga",
  "scrt",
  "stg",
  "step",
  "storj",
  "syn",
  "t",
  "zeta",
  "zk",
  "tao",
  "cloud",
  "sky",
  "zex",
  "turbo",
  "mnt",
  "syrup",
  "kas",
  "render",
] as Array<SecurityCode | SecurityCodeWithoutTransferSupport>);

// Talos -> FA name
export const nameMapEur: { [key: string]: string[] } = {
  "BTC-EUR": ["Bitcoin"],
  "ETH-EUR": ["Ethereum", "Staked Ethereum"],
  "XRP-EUR": ["XRP"],
  "LTC-EUR": ["Litecoin"],
  "EOS-EUR": ["EOS"],
  "ADA-EUR": ["Cardano"],
  "AVAX-EUR": ["Avalanche"],
  "COMP-EUR": ["Compound"],
  "DOT-EUR": ["Polkadot"],
  "KSM-EUR": ["Kusama"],
  "LINK-EUR": ["Chainlink"],
  "MATIC-EUR": ["Polygon"],
  "SOL-EUR": ["Solana"],
  "UNI-EUR": ["Uniswap"],
  "USDC-EUR": ["USDC"],
  "XLM-EUR": ["Stellar"],
  "ATOM-EUR": ["Cosmos"],
  "NEAR-EUR": ["NEAR Protocol"],
  "TRX-EUR": ["TRON"],
  "AAVE-EUR": ["Aave"],
  "XTZ-EUR": ["Tezos"],
  "BCH-EUR": ["Bitcoin Cash"],
  "ETC-EUR": ["Ethereum Classic"],
  "DOGE-EUR": ["Dogecoin"],
  "GLMR-EUR": ["Moonbeam"],
  "XDC-EUR": ["XDC Network"],
  "ALGO-EUR": ["Algorand"],
  "APE-EUR": ["ApeCoin"],
  "GALA-EUR": ["GALA"],
  "GRT-EUR": ["The Graph"],
  "MANA-EUR": ["Decentraland"],
  "SAND-EUR": ["The Sandbox"],
  "APT-EUR": ["Aptos"],
  "AR-EUR": ["Arweave"],
  "ARB-EUR": ["Arbitrum"],
  "BAL-EUR": ["Balancer"],
  "BAT-EUR": ["Basic Attention"],
  "BLUR-EUR": ["Blur"],
  "CRV-EUR": ["Curve DAO"],
  "FIL-EUR": ["Filecoin"],
  "FLOW-EUR": ["Flow"],
  "HBAR-EUR": ["Hedera"],
  "ICP-EUR": ["Internet Computer"],
  "IMX-EUR": ["Immutable"],
  "MKR-EUR": ["Maker"],
  "QNT-EUR": ["Quant"],
  "SNX-EUR": ["Synthetix Network"],
  "SUI-EUR": ["Sui"],
  "YFI-EUR": ["Yearn Finance"],
  "1INCH-EUR": ["1inch"],
  "ACH-EUR": ["Alchemy Pay"],
  "AEVO-EUR": ["Aevo"],
  "AKT-EUR": ["Akash Network"],
  "ANKR-EUR": ["Ankr Network"],
  "API3-EUR": ["API3"],
  "ASTR-EUR": ["Astar"],
  "ATLAS-EUR": ["Star Atlas"],
  "AUDIO-EUR": ["Audius"],
  "AXS-EUR": ["Axie Infinity"],
  "BEAM-EUR": ["Beam"],
  "BOND-EUR": ["BarnBridge"],
  "BONK-EUR": ["Bonk"],
  "CFG-EUR": ["Centrifuge"],
  "CHZ-EUR": ["Chiliz"],
  "DYDX-EUR": ["dYdX"],
  "EGLD-EUR": ["MultiversX"],
  "ENA-EUR": ["Ethena"],
  "ENJ-EUR": ["Enjin Coin"],
  "ENS-EUR": ["Ethereum Name Service"],
  "ETHFI-EUR": ["Ether.fi"],
  "FET-EUR": ["Fetch.ai"],
  "FIDA-EUR": ["Bonfida"],
  "FLR-EUR": ["Flare"],
  "FXS-EUR": ["Frax Share"],
  "GMX-EUR": ["GMX"],
  "GNO-EUR": ["Gnosis"],
  "HFT-EUR": ["Hashflow"],
  "HNT-EUR": ["Helium"],
  "INJ-EUR": ["Injective"],
  "JASMY-EUR": ["JasmyCoin"],
  "JTO-EUR": ["Jito"],
  "JUP-EUR": ["Jupiter"],
  "KAVA-EUR": ["Kava"],
  "LDO-EUR": ["Lido DAO"],
  "LMWR-EUR": ["LimeWire"],
  "LPT-EUR": ["Livepeer"],
  "MINA-EUR": ["Mina Protocol"],
  "MLN-EUR": ["Enzyme"],
  "MOVR-EUR": ["Moonriver"],
  "MPL-EUR": ["Maple"],
  "NOS-EUR": ["Nosana"],
  "OCEAN-EUR": ["Ocean Protocol"],
  "OMG-EUR": ["OMG Network"],
  "ONDO-EUR": ["Ondo"],
  "OP-EUR": ["Optimism"],
  "ORCA-EUR": ["Orca"],
  "PEPE-EUR": ["Pepe"],
  "PERP-EUR": ["Perpetual Protocol"],
  "PYTH-EUR": ["Pyth Network"],
  "RARI-EUR": ["RARI"],
  "RAY-EUR": ["Raydium"],
  "REN-EUR": ["Ren"],
  "RNDR-EUR": ["Render"],
  "RPL-EUR": ["Rocket Pool"],
  "RUNE-EUR": ["THORChain"],
  "SC-EUR": ["Siacoin"],
  "SEI-EUR": ["Sei"],
  "SHIB-EUR": ["Shiba Inu"],
  "STRK-EUR": ["Starknet"],
  "STX-EUR": ["Stacks"],
  "SUPER-EUR": ["SuperVerse"],
  "SUSHI-EUR": ["Sushi"],
  "TIA-EUR": ["Celestia"],
  "TNSR-EUR": ["Tensor"],
  "TRU-EUR": ["TrueFi"],
  "W-EUR": ["Wormhole"],
  "WAVES-EUR": ["Waves"],
  "WEN-EUR": ["Wen"],
  "WIF-EUR": ["dogwifhat"],
  "ZEUS-EUR": ["Zeus Network"],
  "ZRX-EUR": ["0x Protocol"],
  "CVC-EUR": ["Civic"],
  "BTT-EUR": ["BitTorrent"],
  "CLOUD-EUR": ["Cloud"],
  "CPOOL-EUR": ["Clearpool"],
  "ARKM-EUR": ["Arkham"],
  "PRIME-EUR": ["Echelon Prime"],
  "EWT-EUR": ["Energy Web"],
  "DRIFT-EUR": ["Drift Protocol"],
  "FLOKI-EUR": ["FLOKI"],
  "EIGEN-EUR": ["Eigenlayer"],
  "EURC-EUR": ["EURC"],
  "EUL-EUR": ["Euler"],
  "GMT-EUR": ["GMT"],
  "HONEY-EUR": ["Hivemapper"],
  "ICX-EUR": ["ICON"],
  "KMNO-EUR": ["Kamino"],
  "L3-EUR": ["Layer3"],
  "MC-EUR": ["Merit Circle"],
  "LRC-EUR": ["Loopring"],
  "MOG-EUR": ["Mog Coin"],
  "PRCL-EUR": ["Parcl"],
  "SAGA-EUR": ["Saga"],
  "STG-EUR": ["Stargate Finance"],
  "SCRT-EUR": ["Secret"],
  "STORJ-EUR": ["Storj"],
  "SYN-EUR": ["Synapse"],
  "ZK-EUR": ["ZKsync"],
  "PENDLE-EUR": ["Pendle"],
  "T-EUR": ["Threshold Network"],
  "STEP-EUR": ["Step Finance"],
  "POL-EUR": ["POL (ex-MATIC)"],
  "SKY-EUR": ["Sky"],
  "ZETA-EUR": ["ZetaChain"],
  "POPCAT-EUR": ["Popcat"],
  "TURBO-EUR": ["Turbo"],
  "ZEX-EUR": ["Zeta"],
  "TAO-EUR": ["Bittensor"],
  "MNT-EUR": ["Mantle"],
  "TON-EUR": ["Toncoin"],
  "SYRUP-EUR": ["Syrup"],
  "KAS-EUR": ["Kaspa"],
  "RENDER-EUR": ["Render (SOL)"],
  "ABT-EUR": ["Arcblock"],
  "ACA-EUR": ["Acala"],
  "ACE-EUR": ["Fusionist"],
  "ACTSOL-EUR": ["Act I The AI Prophecy"],
  "ACX-EUR": ["Across Protocol"],
  "ADX-EUR": ["AdEx"],
  "AERGO-EUR": ["Aergo"],
  "AERO-EUR": ["Aerodrome Finance"],
  "AGLD-EUR": ["Adventure Gold"],
  "AIOZ-EUR": ["AIOZ Network"],
  "AIXBT-EUR": ["aixbt by Virtuals"],
  "ALICE-EUR": ["My Neighbor Alice"],
  "ALPHA-EUR": ["Stella"],
  "ALT-EUR": ["AltLayer"],
  "AMP-EUR": ["Amp"],
  "ANIME-EUR": ["Animecoin"],
  "ARK-EUR": ["ARK"],
  "ARPA-EUR": ["ARPA"],
  "ATA-EUR": ["Automata"],
  "ATH-EUR": ["Aethir"],
  "AUCTION-EUR": ["Bounce"],
  "AVA-EUR": ["AVA (Travala)"],
  "AXL-EUR": ["Axelar"],
  "BABY-EUR": ["Babylon"],
  "BANANA-EUR": ["Banana Gun"],
  "BAND-EUR": ["Band Protocol"],
  "BEL-EUR": ["Bella Protocol"],
  "BICO-EUR": ["Biconomy"],
  "BIGTIME-EUR": ["Big Time"],
  "BIO-EUR": ["Bio Protocol"],
  "BLAST-EUR": ["Blast"],
  "BLZ-EUR": ["Bluzelle"],
  "BNB-EUR": ["BNB"],
  "BNT-EUR": ["Bancor Network"],
  "BOME-EUR": ["BOOK OF MEME"],
  "BRETT-EUR": ["Brett"],
  "C98-EUR": ["Coin98"],
  "CAKE-EUR": ["PancakeSwap"],
  "CATI-EUR": ["Catizen"],
  "CELO-EUR": ["Celo"],
  "CELR-EUR": ["Celer Network"],
  "CETUS-EUR": ["Cetus Protocol"],
  "CFX-EUR": ["Conflux"],
  "CHILLGUY-EUR": ["Just a chill guy"],
  "CHR-EUR": ["Chromia"],
  "CKB-EUR": ["Nervos Network"],
  "CLV-EUR": ["Clover Finance"],
  "CORE-EUR": ["Core"],
  "COS-EUR": ["Contentos"],
  "COTI-EUR": ["COTI"],
  "COW-EUR": ["CoW Protocol"],
  "CRO-EUR": ["Cronos"],
  "CSPR-EUR": ["Casper Network"],
  "CTC-EUR": ["Creditcoin"],
  "CTK-EUR": ["Shentu"],
  "CTSI-EUR": ["Cartesi"],
  "CVX-EUR": ["Convex Finance"],
  "CYBER-EUR": ["CYBER"],
  "D-EUR": ["Dar Open Network"],
  "DATA-EUR": ["Streamr"],
  "DBR-EUR": ["deBridge"],
  "DCR-EUR": ["Decred"],
  "DEEP-EUR": ["DeepBook"],
  "DEGEN-EUR": ["Degen"],
  "DENT-EUR": ["Dent"],
  "DGB-EUR": ["DigiByte"],
  "DIA-EUR": ["DIA"],
  "DNT-EUR": ["district0x"],
  "DODO-EUR": ["DODO"],
  "DOGS-EUR": ["Dogs"],
  "DUSK-EUR": ["DUSK"],
  "DYM-EUR": ["Dymension"],
  "EDU-EUR": ["Open Campus"],
  "ELX-EUR": ["Elixir"],
  "EPIC-EUR": ["Epic Chain"],
  "EUROP-EUR": ["EURØP"],
  "F-EUR": ["SynFutures"],
  "FIS-EUR": ["Stafi"],
  "FLUX-EUR": ["Flux"],
  "FORM4-EUR": ["Four"],
  "FORTH-EUR": ["Ampleforth Governance"],
  "FUELN-EUR": ["Fuel"],
  "G-EUR": ["Gravity"],
  "GAS-EUR": ["Gas"],
  "GHST-EUR": ["Aavegotchi"],
  "GIGA-EUR": ["Gigachad"],
  "GLM-EUR": ["Golem"],
  "GNS-EUR": ["Gains Network"],
  "GOAT-EUR": ["Goatseus Maximus"],
  "GRASS-EUR": ["Grass"],
  "HEI-EUR": ["Heima"],
  "HIFI-EUR": ["Hifi Finance"],
  "HIGH-EUR": ["Highstreet"],
  "HMSTR-EUR": ["Hamster Kombat"],
  "HOOK-EUR": ["Hooked Protocol"],
  "HOT-EUR": ["Holo"],
  "HYPEL-EUR": ["Hyperliquid"],
  "ID-EUR": ["SPACE ID"],
  "IDEX-EUR": ["IDEX"],
  "ILV-EUR": ["Illuvium"],
  "IO-EUR": ["io.net"],
  "IOST-EUR": ["IOST"],
  "IOTA-EUR": ["IOTA"],
  "IOTX-EUR": ["IoTeX"],
  "IP-EUR": ["Story"],
  "IQ-EUR": ["IQ"],
  "JST-EUR": ["JUST"],
  "KAIA-EUR": ["Kaia"],
  "KAITO-EUR": ["KAITO"],
  "KDA-EUR": ["Kadena"],
  "KERNEL-EUR": ["KernelDAO"],
  "KMD-EUR": ["Komodo"],
  "KNC-EUR": ["Kyber Network Crystal"],
  "LISTA-EUR": ["Lista DAO"],
  "LQTY-EUR": ["Liquity"],
  "LSK-EUR": ["Lisk"],
  "LTO-EUR": ["LTO Network"],
  "LUMIA-EUR": ["Lumia"],
  "LYX-EUR": ["LUKSO"],
  "MAGIC-EUR": ["Treasure"],
  "MANTA-EUR": ["Manta Network"],
  "MASK-EUR": ["Mask Network"],
  "MAV-EUR": ["Maverick Protocol"],
  "MAVIA-EUR": ["Heroes of Mavia"],
  "MBOX-EUR": ["Mobox"],
  "MDT-EUR": ["Measurable Data"],
  "ME-EUR": ["Magic Eden"],
  "MEME-EUR": ["Memecoin"],
  "MERL-EUR": ["Merlin Chain"],
  "METIS-EUR": ["Metis"],
  "MEW-EUR": ["cat in a dogs world"],
  "MICHI-EUR": ["michi"],
  "MOCA-EUR": ["Moca Network"],
  "MOODENG-EUR": ["Moo Deng"],
  "MORPHO-EUR": ["Morpho"],
  "MOVE-EUR": ["Movement"],
  "MTL-EUR": ["Metal DAO"],
  "NANO-EUR": ["Nano"],
  "NEIROCTO-EUR": ["Neiro"],
  "NEO-EUR": ["NEO"],
  "NFP-EUR": ["NFPrompt"],
  "NIL-EUR": ["Nillion"],
  "NKN-EUR": ["NKN"],
  "NMR-EUR": ["Numeraire"],
  "NOT-EUR": ["Notcoin"],
  "NPC-EUR": ["Non-Playable Coin"],
  "OGN-EUR": ["Origin Token"],
  "OM-EUR": ["MANTRA"],
  "OMNI-EUR": ["Omni Network"],
  "ONE-EUR": ["Harmony"],
  "ONG-EUR": ["Ontology Gas"],
  "ONT-EUR": ["Ontology"],
  "ORDI-EUR": ["ORDI"],
  "OSMO-EUR": ["Osmosis"],
  "OXT-EUR": ["Orchid Protocol"],
  "PARTI-EUR": ["Particle Network"],
  "PEAQ-EUR": ["peaq"],
  "PENGU-EUR": ["Pudgy Penguins"],
  "PEOPLE-EUR": ["ConstitutionDAO"],
  "PHA-EUR": ["PHALA"],
  "PHB-EUR": ["Phoenix"],
  "PIXEL-EUR": ["Pixels"],
  "PLUME-EUR": ["Plume"],
  "PNUT-EUR": ["Peanut the Squirrel"],
  "POLS-EUR": ["Polkastarter"],
  "POLYX-EUR": ["Polymesh"],
  "POND-EUR": ["Marlin"],
  "PONKE-EUR": ["PONKE"],
  "PORTAL-EUR": ["Portal"],
  "POWR-EUR": ["Powerledger"],
  "PROM-EUR": ["Prom"],
  "PROMPT-EUR": ["Wayfinder"],
  "PUFFER-EUR": ["Puffer"],
  "PUNDIX-EUR": ["Pundi X"],
  "PYR-EUR": ["Vulcan Forged"],
  "QKC-EUR": ["QuarkChain"],
  "QTUM-EUR": ["Qtum"],
  "RAD-EUR": ["Radworks"],
  "RARE-EUR": ["SuperRare"],
  "RDNT-EUR": ["Radiant Capital"],
  "RED-EUR": ["RedStone"],
  "REQ-EUR": ["Request"],
  "REZ-EUR": ["Renzo"],
  "RLC-EUR": ["iExec RLC"],
  "RONIN-EUR": ["Ronin"],
  "ROSE-EUR": ["Oasis"],
  "RSR-EUR": ["Reserve Rights"],
  "RVN-EUR": ["Ravencoin"],
  "S-EUR": ["Sonic"],
  "SAFE-EUR": ["Safe"],
  "SCR-EUR": ["Scroll"],
  "SFP-EUR": ["SafePal"],
  "SKL-EUR": ["SKALE"],
  "SLF-EUR": ["Self Chain"],
  "SLP-EUR": ["Smooth Love Potion"],
  "SPX-EUR": ["SPX6900"],
  "SSV-EUR": ["SSV Network"],
  "STRAX-EUR": ["Stratis"],
  "SWEAT-EUR": ["Sweat"],
  "SWELL-EUR": ["Swell"],
  "SXP-EUR": ["Solar"],
  "TAI-EUR": ["TARS AI"],
  "TAIKO-EUR": ["Taiko"],
  "THE-EUR": ["Thena"],
  "THETA-EUR": ["Theta Network"],
  "TLM-EUR": ["Alien Worlds"],
  "TOKEN-EUR": ["TokenFi"],
  "TRAC-EUR": ["OriginTrail"],
  "TRB-EUR": ["Tellor Tributes"],
  "TRUMPOFFICIAL-EUR": ["Official Trump"],
  "TWT-EUR": ["Trust Wallet"],
  "UMA-EUR": ["UMA"],
  "UTK-EUR": ["xMoney"],
  "UXLINK-EUR": ["UXLINK"],
  "VANA-EUR": ["Vana"],
  "VANRY-EUR": ["Vanar Chain"],
  "VELO-EUR": ["Velo"],
  "VET-EUR": ["VeChain"],
  "VIC-EUR": ["Viction"],
  "VIRTUAL-EUR": ["Virtuals Protocol"],
  "VRA-EUR": ["Verasity"],
  "VTHO-EUR": ["VeThor"],
  "WAL-EUR": ["Walrus"],
  "WAXP-EUR": ["WAX"],
  "WCT-EUR": ["WalletConnect Token"],
  "WIN-EUR": ["WINkLink"],
  "WLD-EUR": ["Worldcoin"],
  "WOO-EUR": ["WOO"],
  "XAI-EUR": ["Xai"],
  "XVG-EUR": ["Verge"],
  "XYO-EUR": ["XYO Network"],
  "YGG-EUR": ["Yield Guild Games"],
  "ZEN-EUR": ["Horizen"],
  "ZIL-EUR": ["Zilliqa"],
  "ZRC-EUR": ["Zircuit"],
  "ZRO-EUR": ["LayerZero"],
  "INIT-EUR": ["Initia"],
  "SOPH-EUR": ["Sophon"],
  "GTC-EUR": ["Gitcoin"],
  "FARTCOIN-EUR": ["Fartcoin"],
  "SHELL-EUR": ["MyShell"],
  "A-EUR": ["Vaulta"],
  "XION-EUR": ["Xion"],
  "SXT-EUR": ["Space and Time"],
  "HAEDAL-EUR": ["Haedal Protocol"],
  "HOME-EUR": ["HOME"],
  "SPK-EUR": ["Spark"],
  "NEWT-EUR": ["Newton Protocol"],
  "SIGN-EUR": ["Sign"],
  "ICNT-EUR": ["Impossible Cloud Network Token"],
  "DMC-EUR": ["DeLorean"],
  "HUMA-EUR": ["Huma Finance"],
  "PUMP-EUR": ["Pump.fun"],
  "IKA-EUR": ["Ika"],
  "TREE-EUR": ["Treehouse"],
  "SQD-EUR": ["SQD"],
  "TOWNS-EUR": ["Towns"],
  "PROVE-EUR": ["Succinct"],
};

export const nameMapSek: { [key: string]: string[] } = {
  "BTC-SEK": ["Bitcoin"],
  "ETH-SEK": ["Ethereum"],
  "XRP-SEK": ["XRP"],
  "LTC-SEK": ["Litecoin"],
  "EOS-SEK": ["EOS"],
  "ADA-SEK": ["Cardano"],
  "AVAX-SEK": ["Avalanche"],
  "COMP-SEK": ["Compound"],
  "DOT-SEK": ["Polkadot"],
  "KSM-SEK": ["Kusama"],
  "LINK-SEK": ["Chainlink"],
  "MATIC-SEK": ["Polygon"],
  "SOL-SEK": ["Solana"],
  "UNI-SEK": ["Uniswap"],
  "USDC-SEK": ["USDC"],
  "XLM-SEK": ["Stellar"],
  "ATOM-SEK": ["Cosmos"],
  "NEAR-SEK": ["NEAR Protocol"],
  "TRX-SEK": ["TRON"],
  "AAVE-SEK": ["Aave"],
  "XTZ-SEK": ["Tezos"],
  "BCH-SEK": ["Bitcoin Cash"],
  "ETC-SEK": ["Ethereum Classic"],
  "DOGE-SEK": ["Dogecoin"],
  "GLMR-SEK": ["Moonbeam"],
  "XDC-SEK": ["XDC Network"],
  "ALGO-SEK": ["Algorand"],
  "APE-SEK": ["ApeCoin"],
  "GALA-SEK": ["GALA"],
  "GRT-SEK": ["The Graph"],
  "MANA-SEK": ["Decentraland"],
  "SAND-SEK": ["The Sandbox"],
  "APT-SEK": ["Aptos"],
  "AR-SEK": ["Arweave"],
  "ARB-SEK": ["Arbitrum"],
  "BAL-SEK": ["Balancer"],
  "BAT-SEK": ["Basic Attention"],
  "BLUR-SEK": ["Blur"],
  "CRV-SEK": ["Curve DAO"],
  "FIL-SEK": ["Filecoin"],
  "FLOW-SEK": ["Flow"],
  "HBAR-SEK": ["Hedera"],
  "ICP-SEK": ["Internet Computer"],
  "IMX-SEK": ["Immutable"],
  "MKR-SEK": ["Maker"],
  "QNT-SEK": ["Quant"],
  "SNX-SEK": ["Synthetix Network"],
  "SUI-SEK": ["Sui"],
  "YFI-SEK": ["Yearn Finance"],
};

export type CountryCode = string;

export interface Country {
  id: CountryCode;
  labelKey: string;
}

export const COUNTRIES: Country[] = [
  { id: "AF", labelKey: "securities.country.AF" },
  { id: "AL", labelKey: "securities.country.AL" },
  { id: "DZ", labelKey: "securities.country.DZ" },
  { id: "AD", labelKey: "securities.country.AD" },
  { id: "AO", labelKey: "securities.country.AO" },
  { id: "AG", labelKey: "securities.country.AG" },
  { id: "AR", labelKey: "securities.country.AR" },
  { id: "AM", labelKey: "securities.country.AM" },
  { id: "AU", labelKey: "securities.country.AU" },
  { id: "AT", labelKey: "securities.country.AT" },
  { id: "AZ", labelKey: "securities.country.AZ" },
  { id: "BS", labelKey: "securities.country.BS" },
  { id: "BH", labelKey: "securities.country.BH" },
  { id: "BD", labelKey: "securities.country.BD" },
  { id: "BB", labelKey: "securities.country.BB" },
  { id: "BY", labelKey: "securities.country.BY" },
  { id: "BE", labelKey: "securities.country.BE" },
  { id: "BZ", labelKey: "securities.country.BZ" },
  { id: "BJ", labelKey: "securities.country.BJ" },
  { id: "BT", labelKey: "securities.country.BT" },
  { id: "BO", labelKey: "securities.country.BO" },
  { id: "BA", labelKey: "securities.country.BA" },
  { id: "BW", labelKey: "securities.country.BW" },
  { id: "BR", labelKey: "securities.country.BR" },
  { id: "BN", labelKey: "securities.country.BN" },
  { id: "BG", labelKey: "securities.country.BG" },
  { id: "BF", labelKey: "securities.country.BF" },
  { id: "BI", labelKey: "securities.country.BI" },
  { id: "CV", labelKey: "securities.country.CV" },
  { id: "KH", labelKey: "securities.country.KH" },
  { id: "CM", labelKey: "securities.country.CM" },
  { id: "CA", labelKey: "securities.country.CA" },
  { id: "CF", labelKey: "securities.country.CF" },
  { id: "TD", labelKey: "securities.country.TD" },
  { id: "CL", labelKey: "securities.country.CL" },
  { id: "CN", labelKey: "securities.country.CN" },
  { id: "CO", labelKey: "securities.country.CO" },
  { id: "KM", labelKey: "securities.country.KM" },
  { id: "CG", labelKey: "securities.country.CG" },
  { id: "CD", labelKey: "securities.country.CD" },
  { id: "CR", labelKey: "securities.country.CR" },
  { id: "CI", labelKey: "securities.country.CI" },
  { id: "HR", labelKey: "securities.country.HR" },
  { id: "CU", labelKey: "securities.country.CU" },
  { id: "CY", labelKey: "securities.country.CY" },
  { id: "CZ", labelKey: "securities.country.CZ" },
  { id: "DK", labelKey: "securities.country.DK" },
  { id: "DJ", labelKey: "securities.country.DJ" },
  { id: "DM", labelKey: "securities.country.DM" },
  { id: "DO", labelKey: "securities.country.DO" },
  { id: "EC", labelKey: "securities.country.EC" },
  { id: "EG", labelKey: "securities.country.EG" },
  { id: "SV", labelKey: "securities.country.SV" },
  { id: "GQ", labelKey: "securities.country.GQ" },
  { id: "ER", labelKey: "securities.country.ER" },
  { id: "EE", labelKey: "securities.country.EE" },
  { id: "SZ", labelKey: "securities.country.SZ" },
  { id: "ET", labelKey: "securities.country.ET" },
  { id: "FJ", labelKey: "securities.country.FJ" },
  { id: "FI", labelKey: "securities.country.FI" },
  { id: "FR", labelKey: "securities.country.FR" },
  { id: "GA", labelKey: "securities.country.GA" },
  { id: "GM", labelKey: "securities.country.GM" },
  { id: "GE", labelKey: "securities.country.GE" },
  { id: "DE", labelKey: "securities.country.DE" },
  { id: "GH", labelKey: "securities.country.GH" },
  { id: "GR", labelKey: "securities.country.GR" },
  { id: "GD", labelKey: "securities.country.GD" },
  { id: "GT", labelKey: "securities.country.GT" },
  { id: "GN", labelKey: "securities.country.GN" },
  { id: "GW", labelKey: "securities.country.GW" },
  { id: "GY", labelKey: "securities.country.GY" },
  { id: "HT", labelKey: "securities.country.HT" },
  { id: "HN", labelKey: "securities.country.HN" },
  { id: "HU", labelKey: "securities.country.HU" },
  { id: "IS", labelKey: "securities.country.IS" },
  { id: "IN", labelKey: "securities.country.IN" },
  { id: "ID", labelKey: "securities.country.ID" },
  { id: "IR", labelKey: "securities.country.IR" },
  { id: "IQ", labelKey: "securities.country.IQ" },
  { id: "IE", labelKey: "securities.country.IE" },
  { id: "IL", labelKey: "securities.country.IL" },
  { id: "IT", labelKey: "securities.country.IT" },
  { id: "JM", labelKey: "securities.country.JM" },
  { id: "JP", labelKey: "securities.country.JP" },
  { id: "JO", labelKey: "securities.country.JO" },
  { id: "KZ", labelKey: "securities.country.KZ" },
  { id: "KE", labelKey: "securities.country.KE" },
  { id: "KI", labelKey: "securities.country.KI" },
  { id: "KP", labelKey: "securities.country.KP" },
  { id: "KR", labelKey: "securities.country.KR" },
  { id: "KW", labelKey: "securities.country.KW" },
  { id: "KG", labelKey: "securities.country.KG" },
  { id: "LA", labelKey: "securities.country.LA" },
  { id: "LV", labelKey: "securities.country.LV" },
  { id: "LB", labelKey: "securities.country.LB" },
  { id: "LS", labelKey: "securities.country.LS" },
  { id: "LR", labelKey: "securities.country.LR" },
  { id: "LY", labelKey: "securities.country.LY" },
  { id: "LI", labelKey: "securities.country.LI" },
  { id: "LT", labelKey: "securities.country.LT" },
  { id: "LU", labelKey: "securities.country.LU" },
  { id: "MG", labelKey: "securities.country.MG" },
  { id: "MW", labelKey: "securities.country.MW" },
  { id: "MY", labelKey: "securities.country.MY" },
  { id: "MV", labelKey: "securities.country.MV" },
  { id: "ML", labelKey: "securities.country.ML" },
  { id: "MT", labelKey: "securities.country.MT" },
  { id: "MH", labelKey: "securities.country.MH" },
  { id: "MR", labelKey: "securities.country.MR" },
  { id: "MU", labelKey: "securities.country.MU" },
  { id: "MX", labelKey: "securities.country.MX" },
  { id: "FM", labelKey: "securities.country.FM" },
  { id: "MD", labelKey: "securities.country.MD" },
  { id: "MC", labelKey: "securities.country.MC" },
  { id: "MN", labelKey: "securities.country.MN" },
  { id: "ME", labelKey: "securities.country.ME" },
  { id: "MA", labelKey: "securities.country.MA" },
  { id: "MZ", labelKey: "securities.country.MZ" },
  { id: "MM", labelKey: "securities.country.MM" },
  { id: "NA", labelKey: "securities.country.NA" },
  { id: "NR", labelKey: "securities.country.NR" },
  { id: "NP", labelKey: "securities.country.NP" },
  { id: "NL", labelKey: "securities.country.NL" },
  { id: "NZ", labelKey: "securities.country.NZ" },
  { id: "NI", labelKey: "securities.country.NI" },
  { id: "NE", labelKey: "securities.country.NE" },
  { id: "NG", labelKey: "securities.country.NG" },
  { id: "MK", labelKey: "securities.country.MK" },
  { id: "NO", labelKey: "securities.country.NO" },
  { id: "OM", labelKey: "securities.country.OM" },
  { id: "PK", labelKey: "securities.country.PK" },
  { id: "PW", labelKey: "securities.country.PW" },
  { id: "PA", labelKey: "securities.country.PA" },
  { id: "PG", labelKey: "securities.country.PG" },
  { id: "PY", labelKey: "securities.country.PY" },
  { id: "PE", labelKey: "securities.country.PE" },
  { id: "PH", labelKey: "securities.country.PH" },
  { id: "PL", labelKey: "securities.country.PL" },
  { id: "PT", labelKey: "securities.country.PT" },
  { id: "QA", labelKey: "securities.country.QA" },
  { id: "RO", labelKey: "securities.country.RO" },
  { id: "RU", labelKey: "securities.country.RU" },
  { id: "RW", labelKey: "securities.country.RW" },
  { id: "KN", labelKey: "securities.country.KN" },
  { id: "LC", labelKey: "securities.country.LC" },
  { id: "VC", labelKey: "securities.country.VC" },
  { id: "WS", labelKey: "securities.country.WS" },
  { id: "SM", labelKey: "securities.country.SM" },
  { id: "ST", labelKey: "securities.country.ST" },
  { id: "SA", labelKey: "securities.country.SA" },
  { id: "SN", labelKey: "securities.country.SN" },
  { id: "RS", labelKey: "securities.country.RS" },
  { id: "SC", labelKey: "securities.country.SC" },
  { id: "SL", labelKey: "securities.country.SL" },
  { id: "SG", labelKey: "securities.country.SG" },
  { id: "SK", labelKey: "securities.country.SK" },
  { id: "SI", labelKey: "securities.country.SI" },
  { id: "SB", labelKey: "securities.country.SB" },
  { id: "SO", labelKey: "securities.country.SO" },
  { id: "ZA", labelKey: "securities.country.ZA" },
  { id: "SS", labelKey: "securities.country.SS" },
  { id: "ES", labelKey: "securities.country.ES" },
  { id: "LK", labelKey: "securities.country.LK" },
  { id: "SD", labelKey: "securities.country.SD" },
  { id: "SR", labelKey: "securities.country.SR" },
  { id: "SE", labelKey: "securities.country.SE" },
  { id: "CH", labelKey: "securities.country.CH" },
  { id: "SY", labelKey: "securities.country.SY" },
  { id: "TJ", labelKey: "securities.country.TJ" },
  { id: "TZ", labelKey: "securities.country.TZ" },
  { id: "TH", labelKey: "securities.country.TH" },
  { id: "TL", labelKey: "securities.country.TL" },
  { id: "TG", labelKey: "securities.country.TG" },
  { id: "TO", labelKey: "securities.country.TO" },
  { id: "TT", labelKey: "securities.country.TT" },
  { id: "TN", labelKey: "securities.country.TN" },
  { id: "TR", labelKey: "securities.country.TR" },
  { id: "TM", labelKey: "securities.country.TM" },
  { id: "TV", labelKey: "securities.country.TV" },
  { id: "UG", labelKey: "securities.country.UG" },
  { id: "UA", labelKey: "securities.country.UA" },
  { id: "AE", labelKey: "securities.country.AE" },
  { id: "GB", labelKey: "securities.country.GB" },
  { id: "US", labelKey: "securities.country.US" },
  { id: "UY", labelKey: "securities.country.UY" },
  { id: "UZ", labelKey: "securities.country.UZ" },
  { id: "VU", labelKey: "securities.country.VU" },
  { id: "VA", labelKey: "securities.country.VA" },
  { id: "VE", labelKey: "securities.country.VE" },
  { id: "VN", labelKey: "securities.country.VN" },
  { id: "YE", labelKey: "securities.country.YE" },
  { id: "ZM", labelKey: "securities.country.ZM" },
  { id: "ZW", labelKey: "securities.country.ZW" },
];

// Define a function that returns the translation function
export const getTranslation = (i18n: i18n) => {
  return i18n.t.bind(i18n);
};

// When using the country list, you'll need to pass the i18n instance:
// const t = getTranslation(i18n);

// Helper function to transform a Country to Option with translated label
export const countryToOption = (country: Country, t: TFunction): Option => {
  return {
    id: country.id,
    label: t(country.labelKey),
  };
};

// Helper function to transform Countries array to Options array
export const countriesToOptions = (
  countries: Country[],
  t: TFunction
): Option[] => {
  return countries.map((country) => countryToOption(country, t));
};

// Interface for Select component options
export interface Option {
  id: string;
  label: string;
}
